import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import Select, { components } from 'react-select';
import { channelList, complaintTypeOptions2, subDeliveryOptions } from '../../helper/data';
import { useDispatch } from 'react-redux';
import { setAlert, setIsLoading } from '../../store/ui/uiSlice';
import { CloseButton, Form, Modal } from 'react-bootstrap';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

function CForm3(props) {
    const [playVideo, setPlayVideo] = useState(false);
    const [fieldsToShow, setFieldsToShow] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [form3Errors, setForm3Errors] = useState({
        type: false
    });
    const [activeTab, setActiveTab] = useState('product details'); // TODO revert to default value: product details
    const [mainProblemList, setMainProblemList] = useState([]);
    const [subProblemList, setSubProblemList] = useState([]);
    const [commsList, setCommsList] = useState("");
    const [isDisabled, toggleIsDisabled] = useState(false);
    const airBikeId = process.env.REACT_APP_NODE_ENV == 'production' ? 3 : 3;
    const smartWatchId = process.env.REACT_APP_NODE_ENV == 'production' ? 11 : 6;
    const twsId = process.env.REACT_APP_NODE_ENV == 'production' ? 10 : 9;
    const [isCatDisabled, toggleIsCatDisabled] = useState(false);
    const maxDate = new Date().toISOString().split("T")[0];
    const dispatch = useDispatch();
    const tickRef = useRef(null);
    const scrollToRef = useRef(null);
    const [allSubProblemList, setAllSubProblemList] = useState([]);
    const [isFieldDisabled, setIsFieldDsiabled] = useState({
        'pickup-city': false,
        'pickup-state': false,
        'delivery-city': false,
        'delivery-state': false
    });
    const [isCTADisabled, setIsCTADisabled] = useState({
        'productDetailsCTA': true,
        'purchaseDetailsCTA': true,
        'issueDetailsCTA': true,
        'pickUpDetailsCTA': true,
    });

    // tabs for air_bike_installation complaint
    const tabs = {
        'product details': [6, 7],
        // 'purchase details': [1, 5, 2, 10, 11, 18, 19, 20],
        'issue details': [8, 9, 4],
        'pick-Up address': [16],
        'delivery address': [17]
    }
    // tabs for product_quality comaplint
    const tabNew = {
        'product details': [6],
        // 'purchase details': [18],
        'issue details': [8, 4],
        'pick-Up address': [16],
        'delivery address': [17]
    }
    const [showImage, setShowImage] = useState(false);
    const [imgSrc, setImgSrc] = useState({ src: "", type: "" });
    const [completedSteps, setCompletedSteps] = useState([]);
    const [orderItemsList, setorderItemsList] = useState([]);
    const [hasInvoice, sethasInvoice] = useState(false);
    const [showOrdersPopup, setshowOrdersPopup] = useState(false);
    const [ordersList, setOrdersList] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState({
        name: '',
        isChecked: false
    });
    const checkboxWrapperRef = useRef(null);
    // 1-orderId, 2-invoice, 3-images, 4-comments, 5-channel, 6-category, 7-product, 8-mainproblem 
    // 9-subProblem, 10-purchaseDate, 11-deliveryDate, 12-pickupAdrs, 13-deliveryAdrs
    // 14-videos, 15-comments, 16- pick-up address, 17- delivery address, 18- invoice details
    // 19- invoice-value 20- invoice date 21- tick 22- delivery-images 23- delivery-video
    // 24- delivery-message

    // set fields to show as per the selection
    const getFieldsArr = (catList) => {
        if (props.form1Details.type) {
            setCommsList("");
            switch (props.form1Details.type.value) {
                case 'delivery':
                    getMainProblemList(446);
                    break;
                case 'items_missing':
                case 'poor_quality':
                case 'wrong_items':
                    setFieldsToShow([5]);
                    // setMainProblemList([{ label: 'Delivery Related', value: 'Delivery Related' }]);
                    // const list = deliveryRelatedProblemList.map(item => ({ label: item, value: item }));
                    // setSubProblemList(list)
                    toggleIsCatDisabled(false);
                    break;
                case 'product_quality':
                    setFieldsToShow([1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 16, 17, 20, 21]);
                    getMainProblemList(props.form1Details?.category?.value);
                    toggleIsCatDisabled(false);
                    break;
                case 'air_bike_installation':
                    setFieldsToShow([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 13, 14, 17, 18, 19, 20, 21]);
                    toggleIsCatDisabled(true);
                    if (catList) {
                        const item = catList.find(itm => parseInt(itm.value) === airBikeId);
                        if (item) {
                            props.setForm3DetailsHandler((prevState) => ({ ...prevState, category: item }));
                            getProductList(item.value);
                        }
                    }
                    break;
                case 'general_query':
                    getMainProblemList(445);
                    break;
                case 'others':
                    getMainProblemList(448);
                    break;
                case 'orders_related':
                    getMainProblemList(447);
                    break;
                default:
                    break;
            }
        }
    }

    // fetch category list on mount
    useEffect(() => {
        if (!props.form1Details.type ||
            props.form1Details.type?.value == 'product_quality' ||
            props.form1Details.type?.value == 'air_bike_installation') toggleIsDisabled(true);
        dispatch(setIsLoading(true));
        axios.get(process.env.REACT_APP_JAVA_API_URL + 'javacatalog/api/inventoryMaster/fetchActiveCategories')
            .then(res => {
                if (res && res.data.code && Array.isArray(res.data.data) && res.data.data.length) {
                    let updatedList = res.data.data.map(item => ({ label: item.categoryName, value: item.masterCatId }));
                    let smartWatch = updatedList.find(item => item.value == smartWatchId);
                    updatedList = updatedList.filter(item => item.value != smartWatchId);
                    if (smartWatch) updatedList.splice(0, 0, smartWatch);
                    if (updatedList.find(item => item.value == twsId)) {
                        updatedList = updatedList.map(itm => {
                            if (itm.value == twsId) return { label: 'TWS (Earbuds)', value: itm.value };
                            else return itm;
                        });
                    }
                    setCategoryList(updatedList);
                    getFieldsArr(updatedList);
                    dispatch(setIsLoading(false));
                    // props.setForm3DetailsHandler((prevState) => ({ ...prevState, category: updatedList[0] }));
                }
            }).catch(error => {
                dispatch(setIsLoading(false));
            });
    }, [props.form1Details.type]);

    useEffect(() => {
        if (props.form1Details.type?.value !== 'delivery'
            || props.form1Details.type?.value !== 'items_missing'
            || props.form1Details.type?.value !== 'poor_quality'
            || props.form1Details.type?.value !== 'wrong_items'
        ) {
            if (props.form3Details.category) {
                getMainProblemList(props.form3Details.category.value);
                getProductList(props.form3Details.category);
            }
        }
    }, [props.form3Details?.category]);

    useEffect(() => {
        if (props.form3Details.category && props.form3Details.mainProblem && props.form3Details.subProblem) {
            getCommsList(props.form3Details.category.value, props.form3Details.mainProblem.value, props.form3Details.subProblem?.value);
        }
    }, [props.form3Details.category, props.form3Details?.mainProblem, props.form3Details.subProblem]);

    useEffect(() => {
        if (props.form1Details.type?.value === 'product_quality' ||
            props.form1Details.type?.value === 'air_bike_installation'
        ) {
            return;
        }
        if (!props.form3Details.orderId) return;
        dispatch(setIsLoading(true));
        setshowOrdersPopup(false);
        if (selectedOrder?.data) {
            let updatedList = [...selectedOrder?.data.items];
            updatedList = updatedList.map(itm => ({ ...itm, selectedQty: itm.quantity }));
            setorderItemsList(updatedList);
            props.setForm3DetailsHandler(prev => ({
                ...prev,
                invoiceDetails: null,
                images: null,
                comments: null,
                orderDate: null,
                video: null,
                skus: []
            }))
            if (selectedOrder?.data.items[0]?.orderStatus?.length) {
                let item = selectedOrder?.data.items[0]?.orderStatus[0].invoiceUrl;
                sethasInvoice(item);
                if (item) props.setForm3DetailsHandler(prev => ({ ...prev, 'invoiceDetails': item }))
            } else {
                sethasInvoice(null);
            }
            let updated = [...fieldsToShow];
            updated.push(18, 4, 3, 14);
            setFieldsToShow(updated)
            dispatch(setIsLoading(false));
            toggleIsDisabled(false)
        }
    }, [props.form3Details.orderId])

    // reset values on complaint type change
    useEffect(() => {
        setActiveTab('product details');
        if (props.form1Details.type && props.form1Details.type.value !== 'air_bike_installation') {
            props.setForm3DetailsHandler(prev => ({
                ...prev,
                "address": {
                    "address": "",
                    "pincode": '',
                    "city": "",
                    "state": "",
                    "landmark": ""
                },
                "deliveryAddress": {
                    "address": "",
                    "pincode": '',
                    "city": "",
                    "state": "",
                    "landmark": ""
                },
                "channel": null,
                "category": null,
                "product": null,
                "orderId": "",
                "invoice": "",
                "invoiceVal": "",
                "invoiceDate": "",
                "orderDate": "",
                "deliveryDate": "",
                "invoiceDetails": null,
                "subProblem": null,
                "mainProblem": null,
                "images": null,
                "video": null,
                "comments": ""
            }));
            setSelectedOrder({
                name: '',
                isChecked: false
            });
            setorderItemsList([]);
        } else if (props.form1Details.type.value === 'air_bike_installation') {
            props.setForm3DetailsHandler(prev => ({
                ...prev,
                "address": {
                    "address": "",
                    "pincode": '',
                    "city": "",
                    "state": "",
                    "landmark": ""
                },
                "deliveryAddress": {
                    "address": "",
                    "pincode": '',
                    "city": "",
                    "state": "",
                    "landmark": ""
                },
                "channel": null,
                "product": null,
                "orderId": "",
                "invoice": "",
                "invoiceVal": "",
                "invoiceDate": "",
                "orderDate": "",
                "deliveryDate": "",
                "invoiceDetails": null,
                "subProblem": null,
                "mainProblem": null,
                "images": null,
                "video": null,
                "comments": ""
            }));
            setorderItemsList([]);
            setSelectedOrder({
                name: '',
                isChecked: false
            });
        }
    }, [props.form1Details.type]);

    useEffect(() => {
        // fetch orders when customer selects bxp channel for purchase
        if ( ['wrong_items', 'poor_quality', 'items_missing'].includes(props.form1Details.type?.value)
            && props.form3Details.channel?.value
            && props.form3Details.channel?.value === 'BeatXP Website') {
            try {
                dispatch(setIsLoading(true));
                let reqBody = {
                    "currentPage": 1,
                    "perPage": 40,
                    "mobile": props.form1Details.phoneNum,
                };
                axios.post(`${process.env.REACT_APP_JAVA_DASHBOARD}javaOrders/getMyOrdersComplains`, reqBody, {
                    headers: {
                        'Authorization': `Bearer ${props.bearer}`
                    }
                })
                    .then(resp => {
                        if (resp.data.code === 1) {
                            dispatch(setIsLoading(false));
                            setOrdersList(resp.data.data);
                            setshowOrdersPopup(true);
                        } else if (resp.data.code == 4) {
                            dispatch(setIsLoading(false));
                            dispatch(setAlert({ status: true, variant: "danger", msg: resp.data.message }));
                            setTimeout(() => {
                                dispatch(setAlert({ status: false, variant: "danger", msg: "" }));
                            }, 3000);
                        }
                        else {
                            dispatch(setIsLoading(false));
                            dispatch(setAlert({ status: true, variant: "danger", msg: "Oops, Something went wrong" }));
                            setTimeout(() => {
                                dispatch(setAlert({ status: false, variant: "danger", msg: "" }));
                            }, 3000);
                        }
                    }).catch(err => {

                    })
            } catch (error) {
                console.log('error while fecthing orders', error);
            }
        }
    }, [props.form3Details.channel]);

    useEffect(() => {
        if (props.form1Details.type && props.form1Details.type.value !== 'delivery') {
            if (activeTab == 'delivery address') toggleIsDisabled(false);
            else toggleIsDisabled(true);
        }
    }, [activeTab])

    useEffect(()=>{
        if(orderItemsList?.length){
            if(checkboxWrapperRef?.current){
                checkboxWrapperRef.current.querySelector('.product-card .form-check > input').click();
            }
        }
    }, [orderItemsList])

    // useEffect(() => {
    //     if (props.form1Details.type?.value !== 'delivery') {
    //         if (props.form3Details.mainProblem) {
    //             getSubProblemList(props.form3Details.category.value, props.form3Details.mainProblem.value);
    //         } else {
    //             props.setForm3DetailsHandler((prevState) => ({
    //                 ...prevState,
    //                 subProblem: ""
    //             }));
    //             setSubProblemList([]);
    //         }
    //     }
    // }, [props.form3Details?.mainProblem]);

    const getProductList = async (cat) => {
        if (cat && cat.value) {
            let request = {
                "currentPage": 0,
                "perPage": 500,
                "cat_id": parseInt(cat.value)
            };
            axios.post(process.env.REACT_APP_JAVA_API_URL + 'javacatalog/api/inventoryMaster/fetchProductsFilter', request)
                .then(res => {
                    if (res.status == 200 && res.data && Array.isArray(res.data.productList)) {
                        let updatedList = res.data.productList.filter(x => x.status).filter(Boolean).map(item => ({ label: item.inventoryProductName, value: item.inventoryMasterId }));
                        if (props.form1Details.type?.value == 'air_bike_installation') {
                            updatedList = updatedList.filter(item => item.label?.toLowerCase().includes('bike'));
                        }
                        setProductList(updatedList);
                        // props.setForm3DetailsHandler((prevState) => ({ ...prevState, product: updatedList[0] }))
                    }
                })
        }
    }

    const getLocationDets = (pincode, type) => {
        const current = type === 'pickup' ? props.form3Details.address.pincode : props.form3Details.deliveryAddress.pincode;
        if (pincode.length == 6 && pincode.toString() !== current.toString()) {
            axios.get(process.env.REACT_APP_JAVA_API_URL + 'api/pinData/getPinDetails/' + pincode)
                .then(res => {
                    if (res.data.code && res.data.pinDetails) {
                        if (type == 'pickup') {
                            props.setForm3DetailsHandler((prevState) => ({
                                ...prevState,
                                address: {
                                    ...props.form3Details?.address,
                                    city: res.data.pinDetails.city,
                                    state: res.data.pinDetails.state,
                                    pincode: res.data.pinDetails.pincode
                                }
                            }));
                            setIsFieldDsiabled((prevState) => ({
                                ...prevState,
                                'pickup-city': true,
                                'pickup-state': true
                            }));
                        } else {
                            props.setForm3DetailsHandler((prevState) => ({
                                ...prevState,
                                deliveryAddress: {
                                    ...props.form3Details?.deliveryAddress,
                                    city: res.data.pinDetails.city,
                                    state: res.data.pinDetails.state,
                                    pincode: res.data.pinDetails.pincode
                                }
                            }));
                            setIsFieldDsiabled((prevState) => ({
                                ...prevState,
                                'delivery-city': true,
                                'delivery-state': true
                            }));
                        }
                    } else {
                        if (type == 'pickup') {
                            props.setForm3DetailsHandler((prevState) => ({
                                ...prevState,
                                address: {
                                    ...props.form3Details?.address,
                                    city: '',
                                    state: '',
                                    pincode: pincode
                                }
                            }));
                            setIsFieldDsiabled((prevState) => ({
                                ...prevState,
                                'pickup-city': false,
                                'pickup-state': false
                            }));
                        } else {
                            props.setForm3DetailsHandler((prevState) => ({
                                ...prevState,
                                deliveryAddress: {
                                    ...props.form3Details?.deliveryAddress,
                                    city: '',
                                    state: '',
                                    pincode: pincode
                                }
                            }));
                            setIsFieldDsiabled((prevState) => ({
                                ...prevState,
                                'delivery-city': false,
                                'delivery-state': false
                            }));
                        }
                    }
                })
        }
    }

    const getFormErrors = () => {
        let newErrors = {};
        switch (props.form1Details.type.value) {
            case 'product_quality':
                newErrors = {
                    type: !Boolean(props.form1Details.type),
                    // orderId: !Boolean(props.form3Details.orderId),
                    // category: !Boolean(props.form3Details.category),
                    // product: !Boolean(props.form3Details.product),
                    // channel: !Boolean(props.form3Details.channel),
                    // invoice: !Boolean(props.form3Details.invoice),
                    // orderDate: !Boolean(props.form3Details.orderDate),
                    // invoiceVal: !Boolean(props.form3Details.invoiceVal),
                    // invoiceDate: !Boolean(props.form3Details.invoiceDate),
                    // images: !Boolean(props.form3Details.images?.length),
                    // invoiceDetails: !Boolean(props.form3Details.invoiceDetails),
                    // video: !Boolean(props.form3Details.video),
                    // pickupAddress: !Boolean(props.form3Details.address?.address),
                    // pickupAddressCity: !Boolean(props.form3Details.address?.city),
                    // pickupAddressPincode: !Boolean(props.form3Details.address?.pincode),
                    // pickupAddressState: !Boolean(props.form3Details.address?.state),
                    // pickupAddressLandmark: !Boolean(props.form3Details.address?.landmark),
                    // deliveryAddress: !Boolean(props.form3Details.deliveryAddress?.address),
                    // deliveryAddressCity: !Boolean(props.form3Details.deliveryAddress?.city),
                    // deliveryAddressPincode: !Boolean(props.form3Details.deliveryAddress?.pincode),
                    // deliveryAddressState: !Boolean(props.form3Details.deliveryAddress?.state),
                    // deliveryAddressLandmark: !Boolean(props.form3Details.deliveryAddress?.landmark),
                };
                break;
            case 'air_bike_installation':
                newErrors = {
                    type: !Boolean(props.form1Details.type),
                    // orderId: !Boolean(props.form3Details.orderId),
                    category: !Boolean(props.form3Details.category),
                    // product: !Boolean(props.form3Details.product),
                    // orderDate: !Boolean(props.form3Details.orderDate),
                    // channel: !Boolean(props.form3Details.channel),
                    // invoiceDetails: !Boolean(props.form3Details.invoiceDetails),
                    // invoice: !Boolean(props.form3Details.invoice),
                    // invoiceVal: !Boolean(props.form3Details.invoiceVal),
                    // invoiceDate: !Boolean(props.form3Details.invoiceDate),
                    // deliveryAddress: !Boolean(props.form3Details.deliveryAddress?.address),
                    // deliveryAddressCity: !Boolean(props.form3Details.deliveryAddress?.city),
                    // deliveryAddressPincode: !Boolean(props.form3Details.deliveryAddress?.pincode),
                    // deliveryAddressState: !Boolean(props.form3Details.deliveryAddress?.state),
                    // deliveryAddressLandmark: !Boolean(props.form3Details.deliveryAddress?.landmark),
                }
                break;
            case 'general_query':
            case 'orders_related':
            case 'delivery':
            case 'others':
                newErrors = {
                    type: !Boolean(props.form1Details.type),
                }
                break;
            case 'items_missing':
            case 'wrong_items':
            case 'poor_quality':
                newErrors = {
                    type: !Boolean(props.form1Details.type),
                };
                break;
            default:
                break;
        }
        setForm3Errors(newErrors);
        return Object.values(newErrors).filter(Boolean);
    }

    const submitform = () => {
        //TODO check for errors in form, disabled submit btn and then call API handler
        toggleIsDisabled(true);
        if (scrollToRef && scrollToRef.current) scrollToRef.current.scrollIntoView({ block: 'end' });
        if (getFormErrors().length) {
            toggleIsDisabled(false);
            return;
        } else {
            if ((props.form1Details.type?.value === 'items_missing'
                || props.form1Details.type?.value === 'poor_quality'
                || props.form1Details.type?.value === 'wrong_items'
            ) && !props.form3Details.skus?.length) {
                toggleIsDisabled(false);
                dispatch(setAlert({ status: true, variant: "danger", msg: "Please select items for filing complaint." }));
                setTimeout(() => {
                    dispatch(setAlert({ status: false, variant: "danger", msg: "" }));
                }, 3000);
                return;
            }
            props.submitForm3Handler(() => {
                toggleIsDisabled(false);
            });
        }

    }

    const fileUploadHandler = (event, type) => {
        if (event.target.files) {
            let totalSize = 0;
            [...event.target.files].forEach(file => {
                totalSize += file.size
            });
            const max = type == 'video' ? 51200 : 5120;
            if (Math.round(totalSize / 1024) > max) {
                const key = type == 'invoice' ? 'invoiceDetails' : type == 'images' ? 'images' : 'video';
                setForm3Errors({ ...form3Errors, [key]: true });
                dispatch(setAlert({ status: true, variant: "danger", msg: type == 'images' || type === 'invoice' ? "Maximum upload size is 5MB" : "Maximum upload size is 50MB." }));
                setTimeout(() => {
                    dispatch(setAlert({ status: false, variant: "danger", msg: "" }));
                }, 2000);
                return;
            }
            if (type == 'images') {
                props.setForm3DetailsHandler((prevState) => ({
                    ...prevState,
                    images: event.target.files
                }));
                setForm3Errors({ ...form3Errors, images: false });

            } else if (type == 'video') {
                props.setForm3DetailsHandler((prevState) => ({
                    ...prevState,
                    video: event.target.files[0]
                }));
                setForm3Errors({ ...form3Errors, video: false });

            } else if (type == 'invoice') {
                props.setForm3DetailsHandler((prevState) => ({
                    ...prevState,
                    invoiceDetails: event.target.files[0]
                }));
                setForm3Errors({ ...form3Errors, invoiceDetails: false });

            }
        }
    }

    const removeItem = (file, type) => {
        if (type == 'images') {
            let updatedImgsList = [...props.form3Details.images];
            updatedImgsList = updatedImgsList.filter(item => item.name != file);
            props.setForm3DetailsHandler((prevState) => ({
                ...prevState,
                images: updatedImgsList
            }));
        } else if (type == 'video') {
            props.setForm3DetailsHandler((prevState) => ({
                ...prevState,
                video: ""
            }));

        } else if (type == 'invoice') {
            props.setForm3DetailsHandler((prevState) => ({
                ...prevState,
                invoiceDetails: ""
            }));

        }
    }

    const getMainProblemList = (catID) => {
        let newCatId = catID;
        if (props.form1Details.type?.value === 'general_query') newCatId = 445;
        if (props.form1Details.type?.value === 'delivery') newCatId = 446;
        if (props.form1Details.type?.value === 'orders_related') newCatId = 447;
        if (props.form1Details.type?.value === 'others') newCatId = 448;
        if (!newCatId) return;
        let data = JSON.stringify({
            "catId": newCatId
        });

        let config = {
            method: 'post',
            url: `${process.env.REACT_APP_JAVA_API_URL}api/support/fetchProblemsByCatId`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        let list = [];
        axios.request(config)
            .then((response) => {
                if (response.data.code && Array.isArray(response.data.data) && response.data.data.length) {
                    list = response.data.data.map(item => ({ label: item.problem, value: item.problem }));
                    setMainProblemList(list);
                    return;
                    let subList = {};
                    let temp = {}
                    response.data.problemList.forEach(item => {
                        let obj = {};
                        if (Array.isArray(item.subproblemList) && item.subproblemList.length) {
                            obj[item.mainProblem] = item.subproblemList.map(elm => ({ label: elm.subProblem, value: elm.subProblem, subProblemInstruction: elm.subProblemInstruction }));
                        } else {
                            obj[item.mainProblem] = [{ label: "Others", value: "Others" }];
                        }
                        temp = Object.assign(temp, obj);
                    });
                    subList[catID] = temp;
                    setAllSubProblemList(subList);
                    const option = subList[catID][list[0].value];
                    if (option) {
                        setSubProblemList(option)
                        // props.setForm3DetailsHandler((prevState) => ({
                        //     ...prevState,
                        //     mainProblem: list[0],
                        //     subProblem: option[0]
                        // }));
                    } else {
                        setSubProblemList([])
                        // props.setForm3DetailsHandler((prevState) => ({
                        //     ...prevState,
                        //     mainProblem: list[0]
                        // }));
                    }
                } else {
                    setMainProblemList([]);
                    props.setForm3DetailsHandler((prevState) => ({
                        ...prevState,
                        mainProblem: "",
                        subProblem: ""
                    }));
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const getSubProblemList = (catID, mainProblem) => {
        let list = [];
        if (mainProblem && allSubProblemList[catID] && allSubProblemList[catID][mainProblem]) {
            list = allSubProblemList[catID][mainProblem];
            setSubProblemList(list);
            // props.setForm3DetailsHandler((prevState) => ({
            //     ...prevState,
            //     subProblem: list[0]
            // }));
        } else {
            props.setForm3DetailsHandler((prevState) => ({
                ...prevState,
                subProblem: ""
            }));
            setSubProblemList([]);
        }
    }

    const getCommsList = (catID, mainProblem, subProblem) => {
        let list = [];
        if (catID && mainProblem && subProblem && allSubProblemList[catID] && allSubProblemList[catID][mainProblem]) {
            const comms = allSubProblemList[catID][mainProblem].find(elm => elm.value === subProblem);
            if (comms && comms.subProblemInstruction) {
                toggleIsDisabled(true);
                setCommsList(comms);
            }
        } else {
            setCommsList("");
            toggleIsDisabled(false);
        }

    }

    const getHTML = () => {
        if (props.form3Details.invoiceDetails.type === 'application/pdf') {
            return (
                <span className='file-box' key={props.form3Details.invoiceDetails.name}>
                    <svg className='cursor-text' xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M1.23127 12.7945C2.87294 14.4018 5.5428 14.4018 7.18447 12.7945L15.1221 5.02289C16.2926 3.87684 16.2926 2.00559 15.1221 0.859541C13.9516 -0.286514 12.0403 -0.286514 10.8698 0.859541L2.93217 8.63114C2.2328 9.31588 2.2328 10.4444 2.93217 11.1291C3.63156 11.8139 4.78418 11.8139 5.48355 11.1291L12.2872 4.46778C12.4427 4.31976 12.5048 4.10123 12.4496 3.89588C12.3945 3.69052 12.2307 3.53014 12.0209 3.47614C11.8112 3.42213 11.588 3.48287 11.4368 3.6351L4.6331 10.2965C4.39016 10.5343 4.02558 10.5344 3.78264 10.2965C3.53971 10.0586 3.53971 9.70167 3.78264 9.4638L11.7203 1.6922C12.4344 0.993058 13.5576 0.993058 14.2717 1.69222C14.9857 2.39137 14.9857 3.49107 14.2716 4.19021L6.33402 11.9618C5.14877 13.1223 3.26695 13.1223 2.08172 11.9618C0.896489 10.8014 0.896489 8.95891 2.08172 7.79847L8.8854 1.1371C9.04109 0.989109 9.10328 0.770486 9.04816 0.565004C8.99303 0.359522 8.82913 0.199046 8.61926 0.145073C8.40939 0.0910999 8.18609 0.151999 8.03494 0.304433L1.23125 6.96579C-0.41042 8.57314 -0.41042 11.1871 1.23127 12.7945Z" fill="#6C6A6A" />
                    </svg>
                    <span>{props.form3Details.invoiceDetails.name}</span>
                    <button type='button' onClick={() => removeItem(props.form3Details.invoiceDetails.name, 'invoice')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M11.6859 0.314477C11.2671 -0.104315 10.5884 -0.104315 10.1696 0.314477L6 4.48373L1.83036 0.314094C1.41157 -0.104698 0.732886 -0.104698 0.314094 0.314094C-0.104698 0.732886 -0.104698 1.41157 0.314094 1.83036L4.48374 6L0.314094 10.1696C-0.104698 10.5884 -0.104698 11.2671 0.314094 11.6859C0.732886 12.1047 1.41157 12.1047 1.83036 11.6859L6 7.51627L10.1696 11.6859C10.5884 12.1047 11.2671 12.1047 11.6859 11.6859C12.1047 11.2671 12.1047 10.5884 11.6859 10.1696L7.51627 6L11.6859 1.83036C12.1047 1.41157 12.1047 0.732886 11.6859 0.314094V0.314477Z" fill="#FF8300" />
                        </svg>
                    </button>
                </span>
            )
        } else {
            return (
                <span className='file-box-image' key={props.form3Details.invoiceDetails.name}
                    style={{
                        backgroundImage: `url(${URL.createObjectURL(props.form3Details.invoiceDetails)})`
                    }}>
                    {/* {item.name.slice(0, 10)} */}
                    <button type='button'>
                        <span onClick={() => { setImgSrc({ src: props.form3Details.invoiceDetails, type: 'img' }); setShowImage(true) }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M7.50026 5C6.39754 5 5.49991 5.89759 5.49991 6.99965C5.49991 8.10242 6.39754 9 7.50026 9C8.60299 9 9.50061 8.10242 9.50061 6.99965C9.50061 5.89759 8.60299 5 7.50026 5ZM7.49947 10C5.84276 10 4.5 8.65721 4.5 6.99974C4.5 5.3428 5.84276 4 7.49947 4C9.15619 4 10.4989 5.3428 10.4989 6.99974C10.4989 8.65721 9.15619 10 7.49947 10ZM7.5 12C10.4788 12 13.3987 9.31873 13.976 6.9998C13.3987 4.68119 10.4787 2 7.5 2C4.52103 2 1.60131 4.68101 1.02397 6.9998C1.60127 9.31891 4.52095 12 7.5 12ZM0 6.99977C0.416593 4.85706 3.35733 1 7.5 1C11.6422 1 14.5834 4.85706 15 6.99977C14.5834 9.14294 11.6422 13 7.5 13C3.35733 13 0.416593 9.14294 0 6.99977Z" fill="white" />
                            </svg>
                        </span>
                        <span onClick={() => removeItem(props.form3Details.invoiceDetails.name, 'invoice')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                <path d="M13.0256 2.15385H10.5329L10.2895 1.4761C10.0871 0.605231 9.38851 0 8.57723 0H5.98687C5.17631 0 4.47703 0.605231 4.27456 1.4761L4.03118 2.15385H1.53846C1.24123 2.15385 1 2.39508 1 2.69231C1 2.98954 1.24123 3.23077 1.53846 3.23077H2.4359V12.0256C2.4359 13.1148 3.32113 14 4.41026 14H10.1538C11.243 14 12.1282 13.1148 12.1282 12.0256V3.23077H13.0256C13.3229 3.23077 13.5641 2.98954 13.5641 2.69231C13.5641 2.39508 13.3229 2.15385 13.0256 2.15385ZM5.29979 1.8078L5.31918 1.73887C5.40246 1.34903 5.67744 1.07692 5.98687 1.07692H8.57723C8.88667 1.07692 9.16092 1.34903 9.24492 1.73887L9.38851 2.15385H5.17559L5.29979 1.8078ZM11.0513 12.0256C11.0513 12.5203 10.6485 12.9231 10.1538 12.9231H4.41026C3.91559 12.9231 3.51282 12.5203 3.51282 12.0256V3.23077H11.0513V12.0256ZM5.30769 9.87179V6.28205C5.30769 5.98482 5.54892 5.74359 5.84615 5.74359C6.14338 5.74359 6.38461 5.98482 6.38461 6.28205V9.87179C6.38461 10.169 6.14338 10.4103 5.84615 10.4103C5.54892 10.4103 5.30769 10.169 5.30769 9.87179ZM8.17949 9.87179V6.28205C8.17949 5.98482 8.42072 5.74359 8.71795 5.74359C9.01518 5.74359 9.25641 5.98482 9.25641 6.28205V9.87179C9.25641 10.169 9.01518 10.4103 8.71795 10.4103C8.42072 10.4103 8.17949 10.169 8.17949 9.87179Z" fill="white" />
                            </svg>
                        </span>
                    </button>
                </span>
            )
        }
    }
    const DropdownIndicator = props => {
        if (props.isDisabled) return null;
        return (
            components.DropdownIndicator && (
                <components.DropdownIndicator {...props}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M1.8443 0.303668C1.4392 -0.101223 0.7828 -0.101223 0.3776 0.303668C-0.0272007 0.708764 -0.0272008 1.36517 0.3776 1.77031L6.30367 7.69633C6.70876 8.10122 7.36517 8.10122 7.77031 7.69633L13.6963 1.77031C14.1012 1.36521 14.1012 0.708807 13.6963 0.303668C13.2912 -0.101222 12.6348 -0.101222 12.2297 0.303668L7.0341 5.49926L1.8443 0.303668Z" fill="#FF8300" />
                    </svg>
                </components.DropdownIndicator>
            )
        );
    };

    const goToNextStep = (action, currentStep, nextStep, prevStep) => {
        let newErrors = {};
        if (action === 'next') {
            switch (props.form1Details.type?.value) {
                case 'product_quality':
                    switch (currentStep) {
                        case 'product details':
                            newErrors = {
                                category: !Boolean(props.form3Details.category),
                                // product: !Boolean(props.form3Details.product)
                            };
                            setForm3Errors(newErrors);
                            if (Object.values(newErrors).filter(Boolean).length) break;
                            else {
                                props.setForm3DetailsHandler(prevState => ({
                                    ...prevState,
                                    subProblem: ""
                                }));
                                setActiveTab(nextStep);
                                setCompletedSteps(prevState => [...prevState, 'purchase details', 'issue details'].filter((value, index, array) => array.indexOf(value) === index));
                                setIsCTADisabled(prevState => ({ ...prevState, issueDetailsCTA: false }))
                                if (scrollToRef && scrollToRef.current) scrollToRef.current.scrollIntoView({ block: 'end' });
                            }
                            break;
                        case 'purchase details':
                            newErrors = {
                                // orderId: !Boolean(props.form3Details.orderId),
                                // channel: !Boolean(props.form3Details.channel),
                                // invoice: !Boolean(props.form3Details.invoice),
                                // orderDate: !Boolean(props.form3Details.orderDate),
                                // invoiceVal: !Boolean(props.form3Details.invoiceVal),
                                // invoiceDate: !Boolean(props.form3Details.invoiceDate),
                                invoiceDetails: !Boolean(props.form3Details.invoiceDetails)
                            };
                            setForm3Errors(newErrors);
                            if (Object.values(newErrors).filter(Boolean).length) {
                                if (scrollToRef && scrollToRef.current) scrollToRef.current.scrollIntoView({ block: 'end' });
                                break;
                            }
                            else {
                                props.setForm3DetailsHandler(prevState => ({
                                    ...prevState,
                                    subProblem: ""
                                }));
                                setActiveTab(nextStep);
                                setCompletedSteps(prevState => [...prevState, 'purchase details', 'issue details'].filter((value, index, array) => array.indexOf(value) === index));
                                if (scrollToRef && scrollToRef.current) scrollToRef.current.scrollIntoView({ block: 'end' });
                            }
                            break;
                        case 'issue details':
                            newErrors = {
                                // images: !Boolean(props.form3Details.images?.length),
                                // video: !Boolean(props.form3Details.video)
                            };
                            setForm3Errors(newErrors);
                            if (Object.values(newErrors).filter(Boolean).length) break;
                            else {
                                setCompletedSteps(prevState => [...prevState, 'issue details', 'pick-Up address'].filter((value, index, array) => array.indexOf(value) === index));
                                setActiveTab(nextStep);
                            }
                            if (scrollToRef && scrollToRef.current) scrollToRef.current.scrollIntoView({ block: 'end' });
                            break;
                        case 'pick-Up address':
                            // newErrors = {
                            //     pickupAddress: !Boolean(props.form3Details.address?.address),
                            //     pickupAddressCity: !Boolean(props.form3Details.address?.city),
                            //     pickupAddressPincode: !Boolean(props.form3Details.address?.pincode),
                            //     pickupAddressState: !Boolean(props.form3Details.address?.state),
                            //     pickupAddressLandmark: !Boolean(props.form3Details.address?.landmark)
                            // };
                            // setForm3Errors(newErrors);
                            // if (Object.values(newErrors).filter(Boolean).length) break;
                            // else {
                            if (tickRef && tickRef.current && tickRef.current.checked) {
                                props.setForm3DetailsHandler(prevState => (
                                    {
                                        ...prevState,
                                        deliveryAddress: {
                                            address: props.form3Details.address?.address,
                                            city: props.form3Details.address?.city,
                                            state: props.form3Details.address?.state,
                                            pincode: props.form3Details.address?.pincode,
                                            landmark: props.form3Details.address?.landmark
                                        }
                                    }
                                ));
                            }
                            toggleIsDisabled(false);
                            setActiveTab(nextStep);
                            setCompletedSteps(prevState => [...prevState, 'pick-Up address', 'delivery address'].filter((value, index, array) => array.indexOf(value) === index));
                            // }
                            break;
                        case 'delivery address':
                            // newErrors = {
                            //     deliveryAddress: !Boolean(props.form3Details.deliveryAddress?.address),
                            //     deliveryAddressCity: !Boolean(props.form3Details.deliveryAddress?.city),
                            //     deliveryAddressPincode: !Boolean(props.form3Details.deliveryAddress?.pincode),
                            //     deliveryAddressState: !Boolean(props.form3Details.deliveryAddress?.state),
                            //     deliveryAddressLandmark: !Boolean(props.form3Details.deliveryAddress?.landmark),
                            // };
                            // setForm3Errors(newErrors);
                            // if (Object.values(newErrors).filter(Boolean).length) break;
                            // else 
                            setActiveTab(nextStep)
                            break;
                        default:
                            break;
                    }
                    break;
                case 'air_bike_installation':
                    switch (currentStep) {
                        case 'product details':
                            newErrors = {
                                category: !Boolean(props.form3Details.category),
                                // product: !Boolean(props.form3Details.product)
                            };
                            setForm3Errors(newErrors);
                            if (Object.values(newErrors).filter(Boolean).length) break;
                            else {
                                setActiveTab(nextStep);
                                setCompletedSteps(prevState => [...prevState, 'purchase details'].filter((value, index, array) => array.indexOf(value) === index));
                            }
                            break;
                        case 'purchase details':
                            // newErrors = {
                            //     // orderId: !Boolean(props.form3Details.orderId),
                            //     // channel: !Boolean(props.form3Details.channel),
                            //     // invoice: !Boolean(props.form3Details.invoice),
                            //     // orderDate: !Boolean(props.form3Details.orderDate),
                            //     // invoiceVal: !Boolean(props.form3Details.invoiceVal),
                            //     // invoiceDate: !Boolean(props.form3Details.invoiceDate),
                            //     invoiceDetails: !Boolean(props.form3Details.invoiceDetails)
                            // };
                            // setForm3Errors(newErrors);
                            // if (Object.values(newErrors).filter(Boolean).length) {
                            //     if (scrollToRef && scrollToRef.current) scrollToRef.current.scrollIntoView({ block: 'end' });
                            //     break;
                            // }
                            // else {
                            props.setForm3DetailsHandler(prevState => ({
                                ...prevState,
                                subProblem: ""
                            }));
                            setActiveTab(nextStep);
                            setCompletedSteps(prevState => [...prevState, 'purchase details', 'issue details'].filter((value, index, array) => array.indexOf(value) === index));
                            if (scrollToRef && scrollToRef.current) scrollToRef.current.scrollIntoView({ block: 'end' });
                            // }
                            break;
                        case 'issue details':
                            // newErrors = {
                            //     images: !Boolean(props.form3Details.images),
                            //     video: !Boolean(props.form3Details.video)
                            // };
                            // setForm3Errors(newErrors);
                            // if (Object.values(newErrors).filter(Boolean).length) return;
                            // else 
                            setActiveTab(nextStep)
                            setCompletedSteps(prevState => [...prevState, 'delivery address', 'issue details'].filter((value, index, array) => array.indexOf(value) === index));
                            if (scrollToRef && scrollToRef.current) scrollToRef.current.scrollIntoView({ block: 'end' });
                            break;
                        case 'delivery address':
                            // newErrors = {
                            //     deliveryAddress: !Boolean(props.form3Details.deliveryAddress?.address),
                            //     deliveryAddressCity: !Boolean(props.form3Details.deliveryAddress?.city),
                            //     deliveryAddressPincode: !Boolean(props.form3Details.deliveryAddress?.pincode),
                            //     deliveryAddressState: !Boolean(props.form3Details.deliveryAddress?.state),
                            //     deliveryAddressLandmark: !Boolean(props.form3Details.deliveryAddress?.landmark),
                            // };
                            // setForm3Errors(newErrors);
                            // if (Object.values(newErrors).filter(Boolean).length) break;
                            // else 
                            setActiveTab(nextStep)
                            break;
                        default:
                            break;
                    }
                    break;

                default:
                    break;
            }
        } else if (action === 'prev') {
            setActiveTab(prevStep);
            if (scrollToRef && scrollToRef.current) scrollToRef.current.scrollIntoView({ block: 'end' });
        }
    }

    const getFields = () => {
        switch (props.form1Details.type?.value) {
            case 'items_missing':
            case 'poor_quality':
            case 'wrong_items':
                return <>
                    <div className="did-floating-label-content">
                        <label className="did-floating-label">Purchase Channel<span className='text-danger'>*</span></label>
                        <Select
                            className="basic-single "
                            classNamePrefix="select"
                            isSearchable
                            name="channel"
                            options={channelList}
                            classNames={{
                                control: (state) =>
                                    form3Errors.channel ? 'border-error' : '',
                            }}
                            components={{ DropdownIndicator }}
                            placeholder="Select purchase channel"
                            styles={{
                                menu: (baseStyles) => ({
                                    ...baseStyles,
                                    zIndex: 2,
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    textAlign: 'left'
                                }),
                                singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    textAlign: 'left'
                                }),
                                control: (baseStyles) => ({
                                    ...baseStyles,
                                    fontSize: '16px',
                                    background: '#fff',
                                    color: '#323840',
                                    border: '1px solid var(--input-border-color)',
                                    borderColor: 'var(--input-border-color)',
                                    borderRadius: '10px',
                                    boxSizing: 'border-box',
                                    height: '50px',
                                    textAlign: 'left',
                                    '&:hover': {
                                        borderColor: 'var(--input-border-color)'
                                    }
                                }),
                                placeholder: (baseStyles) => ({
                                    ...baseStyles,
                                    color: 'var(--border-color)'
                                }),
                                indicatorSeparator: (baseStyles) => ({
                                    display: 'none'
                                }),
                                container: (baseStyles) => ({
                                    ...baseStyles,
                                    width: '100%'
                                }),
                                dropdownIndicator: (baseStyles) => ({
                                    ...baseStyles,
                                    '& svg': {
                                        fill: '#000'
                                    }
                                })
                            }}
                            value={props.form3Details.channel}
                            // onBlur={getFormErrors}
                            // defaultValue={props.form3Details.channel}
                            onChange={(value) => {
                                props.setForm3DetailsHandler((prevState) => ({
                                    ...prevState,
                                    channel: value
                                }))
                                if (value.value === 'BeatXP Website') {
                                    setFieldsToShow([]);
                                    // toggleIsDisabled(false);
                                } else {
                                    setFieldsToShow([24]);
                                    props.setForm3DetailsHandler(prev => ({
                                        ...prev,
                                        invoiceDetails: null,
                                        // images: null,
                                        // orderId: null,
                                        comments: null,
                                        orderDate: null,
                                        // video: null,
                                        skus: [],
                                        type: null
                                    }))
                                    setorderItemsList([]);
                                    toggleIsDisabled(true);
                                }
                            }}
                        />
                        {
                            form3Errors.channel ? <span className='error-msg'>Please select channel</span> : null
                        }
                    </div>

                    {
                        orderItemsList && orderItemsList.length ? <div className='did-floating-label-content  product-cards-wrapper'
                            ref={checkboxWrapperRef}>
                            <h5 className='did-floating-label'>Ordered Items:&nbsp; <span className='text-brand'>(select the items of concern)</span></h5>
                            {
                                orderItemsList.map(itm => (
                                    <div className='product-card' key={itm.itemId}>
                                        <Form.Check // prettier-ignore
                                            type={'checkbox'}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    // add item to list
                                                    let updated = props.form3Details.skus || [];
                                                    let current = orderItemsList.find(i => i.sku === itm.sku);
                                                    updated.push({ 'sku': itm.sku, 'quantity': current?.selectedQty || current?.quantity });
                                                    props.setForm3DetailsHandler(prev => ({ ...prev, skus: updated, orderId: itm.orderId }));
                                                } else {
                                                    // remove from list if present
                                                    let updated = props.form3Details.skus || [];
                                                    if (updated.length) {
                                                        updated = updated.filter(sku => sku.sku !== itm.sku);
                                                        props.setForm3DetailsHandler(prev => ({ ...prev, skus: updated, orderId: null }));
                                                    }
                                                }
                                            }}
                                        />
                                        <div className='d-flex flex-column'>
                                            <span>{itm.productName}</span>
                                            <span>₹ {itm.price}</span>
                                            <span><b>Order ID: &nbsp;</b>{itm.orderId}</span>
                                            <div className='mt-3'>
                                                <button disabled={itm.selectedQty === 1} type='button' className='btn btn-outline-warning text-dark mr-3 w-auto'
                                                    onClick={() => {
                                                        let updatedList = [...orderItemsList];
                                                        updatedList = updatedList.map(m => ({ ...m, selectedQty: m.itemId === itm.itemId ? m.selectedQty - 1 : m.selectedQty }))
                                                        setorderItemsList(updatedList);
                                                    }}>-</button>
                                                <span className='btn btn-outline-warning text-dark mr-3 w-auto'>{itm.selectedQty}</span>
                                                <button disabled={itm.selectedQty >= itm.quantity} type='button' className='btn btn-outline-warning text-dark w-auto'
                                                    onClick={() => {
                                                        let updatedList = [...orderItemsList];
                                                        updatedList = updatedList.map(m => ({ ...m, selectedQty: m.itemId === itm.itemId ? m.selectedQty + 1 : m.selectedQty }))
                                                        setorderItemsList(updatedList);
                                                    }}>+</button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div> : null
                    }
                    {fieldsToShow?.includes(4) ? <div className="did-floating-label-content w-100 flex-basis-unset">
                        <label className="did-floating-label">Remarks</label>
                        <textarea className="did-floating-input" placeholder="Describe your problem in detail"
                            value={props.form3Details.comments || ''}
                            style={{
                                height: '80px'
                            }}
                            onChange={(event) => {
                                event.persist();
                                props.setForm3DetailsHandler((prevState) => ({
                                    ...prevState,
                                    comments: event.target.value
                                }))
                            }} />
                    </div> : null}

                    {
                        fieldsToShow?.includes(24) ?
                            <div style={{ flexBasis: '100%' }}>
                                <p className='msg-box'>Please contact the {props.form3Details?.channel?.label} Customer Support Team.</p>
                            </div> : null
                    }
                    <button type='button' className='btn btn-brand text-white'
                        onClick={submitform}>Submit your complaint
                    </button>
                </>
            case 'general_query':
            case 'orders_related':
            case 'delivery':
            case 'others':
                return <>
                    <div className='div-fields-wrapper'>
                        <div className="did-floating-label-content">
                            <label className="did-floating-label">Problem</label>
                            <Select
                                className="basic-single "
                                classNamePrefix="select"
                                isSearchable
                                name="main-problem"
                                components={{ DropdownIndicator }}
                                placeholder="Select Problem"
                                options={mainProblemList}
                                classNames={{
                                    control: (state) =>
                                        form3Errors.mainProblem ? 'border-error' : '',
                                }}
                                styles={{
                                    container: (baseStyles) => ({
                                        ...baseStyles,
                                        width: '100%'
                                    }),
                                    menu: (baseStyles) => ({
                                        ...baseStyles,
                                        zIndex: 2,
                                    }),
                                    menuList: (baseStyles, state) => ({
                                        ...baseStyles,
                                        textAlign: 'left'
                                    }),
                                    singleValue: (baseStyles, state) => ({
                                        ...baseStyles,
                                        textAlign: 'left'
                                    }),
                                    control: (baseStyles) => ({
                                        ...baseStyles,
                                        fontSize: '16px',
                                        background: '#fff',
                                        border: '1px solid  var(--input-border-color)',
                                        borderColor: ' var(--input-border-color)',
                                        borderRadius: '10px',
                                        boxSizing: 'border-box',
                                        height: '50px',
                                        textAlign: 'left',
                                        minWidth: '290px',
                                        '&:hover': {
                                            borderColor: ' var(--input-border-color)'
                                        }
                                    }),
                                    placeholder: (baseStyles) => ({
                                        ...baseStyles,
                                        color: 'var(--border-color)'
                                    }),
                                    indicatorSeparator: (baseStyles) => ({
                                        display: 'none'
                                    }),
                                    dropdownIndicator: (baseStyles) => ({
                                        ...baseStyles,
                                        '& svg': {
                                            fill: '#000'
                                        }
                                    })
                                }}
                                value={props.form3Details.mainProblem}
                                // onBlur={getFormErrors}
                                // defaultValue={mainProblemList[0]}
                                onChange={(value) => {
                                    props.setForm3DetailsHandler((prevState) => ({
                                        ...prevState,
                                        mainProblem: value
                                    }));
                                }}
                            />
                        </div>
                    </div>

                    <div className="did-floating-label-content w-100 flex-basis-unset">
                        <label className="did-floating-label">Remarks</label>
                        <textarea className="did-floating-input" placeholder="Describe your problem in detail"
                            value={props.form3Details.comments || ''}
                            style={{
                                height: '80px'
                            }}
                            onChange={(event) => {
                                event.persist();
                                props.setForm3DetailsHandler((prevState) => ({
                                    ...prevState,
                                    comments: event.target.value
                                }))
                            }} />
                    </div>
                    <button type='button' className='btn btn-brand text-white'
                        onClick={submitform}>Submit your complaint
                    </button>
                </>
            case 'product_quality':
                switch (activeTab) {
                    case 'product details':
                        return <>
                            {
                                tabNew[activeTab].includes(6) ?
                                    <div className="did-floating-label-content catName">
                                        <label className="did-floating-label">Product Category<span className='text-danger'>*</span></label>
                                        <Select
                                            className="basic-single w-100"
                                            classNamePrefix="select"
                                            isSearchable
                                            name="type"
                                            options={categoryList}
                                            isDisabled={isCatDisabled}
                                            components={{ DropdownIndicator }}
                                            placeholder="Select product category"
                                            classNames={{
                                                control: (state) =>
                                                    form3Errors.category ? 'border-error' : '',
                                            }}
                                            styles={{
                                                menu: (baseStyles) => ({
                                                    ...baseStyles,
                                                    zIndex: 2,
                                                }),
                                                menuList: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    textAlign: 'left'
                                                }),
                                                singleValue: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    textAlign: 'left'
                                                }),
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    fontSize: '16px',
                                                    background: '#fff',
                                                    color: '#323840',
                                                    border: '1px solid var(--input-border-color)',
                                                    borderColor: 'var(--input-border-color)',
                                                    borderRadius: '10px',
                                                    boxSizing: 'border-box',
                                                    height: '50px',
                                                    textAlign: 'left',
                                                    '&:hover': {
                                                        borderColor: 'var(--input-border-color)'
                                                    }
                                                }),
                                                placeholder: (baseStyles) => ({
                                                    ...baseStyles,
                                                    color: 'var(--border-color)'
                                                }),
                                                indicatorSeparator: (baseStyles) => ({
                                                    display: 'none'
                                                }),
                                                dropdownIndicator: (baseStyles) => ({
                                                    ...baseStyles,
                                                    '& svg': {
                                                        fill: '#000'
                                                    }
                                                })
                                            }}
                                            value={props.form3Details.category}
                                            // onBlur={getFormErrors}
                                            // defaultValue={categoryList[0]}
                                            onChange={(value) => {
                                                if (value) {
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        category: value
                                                    }));
                                                    setIsCTADisabled(prevState => ({ ...prevState, productDetailsCTA: false }))
                                                }
                                                else
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        product: null
                                                    }));
                                            }}
                                        />
                                        {
                                            form3Errors.category ? <span className='error-msg'>Please select category</span> : null
                                        } </div>
                                    : null
                            }
                            {
                                tabNew[activeTab].includes(7) ? <div className="did-floating-label-content w-100">
                                    <label className="did-floating-label">Product<span className='text-danger'>*</span></label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable
                                        name="products"
                                        components={{ DropdownIndicator }}
                                        placeholder="Select product"
                                        options={productList}
                                        classNames={{
                                            control: (state) =>
                                                form3Errors.product ? 'border-error' : '',
                                        }}
                                        styles={{
                                            container: (baseStyles) => ({
                                                ...baseStyles,
                                                width: '100%'
                                            }),
                                            menu: (baseStyles) => ({
                                                ...baseStyles,
                                                zIndex: 2,
                                            }),
                                            menuList: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            singleValue: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                fontSize: '16px',
                                                background: '#fff',
                                                color: '#323840',
                                                border: '1px solid var(--input-border-color)',
                                                borderColor: 'var(--input-border-color)',
                                                borderRadius: '10px',
                                                boxSizing: 'border-box',
                                                height: '50px',
                                                textAlign: 'left',
                                                '&:hover': {
                                                    borderColor: 'var(--input-border-color)'
                                                }
                                            }),
                                            placeholder: (baseStyles) => ({
                                                ...baseStyles,
                                                color: 'var(--border-color)'
                                            }),
                                            indicatorSeparator: (baseStyles) => ({
                                                display: 'none'
                                            }),
                                            dropdownIndicator: (baseStyles) => ({
                                                ...baseStyles,
                                                '& svg': {
                                                    fill: '#000'
                                                }
                                            })
                                        }}
                                        value={props.form3Details.product}
                                        // defaultValue={productList[0]}
                                        // onBlur={getFormErrors}
                                        onChange={(value) => {
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                product: value
                                            }))
                                            setIsCTADisabled(prevState => ({ ...prevState, productDetailsCTA: false }))
                                        }}
                                    />
                                    {
                                        form3Errors.product ? <span className='error-msg'>Please select product</span> : null
                                    }
                                </div> : null
                            }
                            <button type='button' disabled={isCTADisabled?.productDetailsCTA} style={{ marginTop: "40px" }} className='btn btn-outline' onClick={() => goToNextStep('next', 'product details', 'issue details', '')}>Next Section</button>
                        </>
                    case 'purchase details':
                        return <>
                            {
                                tabNew[activeTab].includes(1) ? <div className="did-floating-label-content ">
                                    <label className="did-floating-label">Order ID<span className='text-danger'>*</span></label>
                                    <input className={`did-floating-input ${form3Errors.orderId ? 'border-error' : ''}`} type="text" placeholder="Enter Order ID"
                                        value={props.form3Details.orderId || ''}
                                        // onBlur={getFormErrors}
                                        onChange={(event) => {
                                            event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                orderId: event.target.value
                                            }))
                                        }}
                                    />
                                    {
                                        form3Errors.orderId ? <span className='error-msg'>Please enter order id</span> : null
                                    }
                                </div> : null
                            }
                            {
                                tabNew[activeTab].includes(5) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label">Purchase Channel<span className='text-danger'>*</span></label>
                                    <Select
                                        className="basic-single "
                                        classNamePrefix="select"
                                        isSearchable
                                        name="channel"
                                        options={[{ "label": "Amazon", "value": "Amazon" }, { "label": "Flipkart", "value": "Flipkart" }, { "label": "1 MG", "value": "1 MG" }, { "label": "BeatXP Website", "value": "BeatXP Website" }, { "label": "Jio Mart", "value": "Jio Mart" }, { "label": "Snapdeal", "value": "Snapdeal" }, { "label": "Netmeds", "value": "Netmeds" }, { "label": "Meesho", "value": "Meesho" }, { "label": "Moblix", "value": "Moblix" }, { "label": "Nyka", "value": "Nyka" }, { "label": "Tata Cliq", "value": "Tata Cliq" }, { "label": "Shopclues", "value": "Shopclues" }, { "label": "Pharmeasy", "value": "Pharmeasy" }, { "label": "Myntra", "value": "Myntra" }, { "label": "Cred", "value": "Cred" }, { "label": "Blinkit", "value": "Blinkit" }, { "label": "B2B", "value": "B2B" }, { "label": "Others", "value": "Others" }]}
                                        classNames={{
                                            control: (state) =>
                                                form3Errors.channel ? 'border-error' : '',
                                        }}
                                        components={{ DropdownIndicator }}
                                        placeholder="Select purchase channel"
                                        styles={{
                                            menu: (baseStyles) => ({
                                                ...baseStyles,
                                                zIndex: 2,
                                            }),
                                            menuList: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            singleValue: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                fontSize: '16px',
                                                background: '#fff',
                                                color: '#323840',
                                                border: '1px solid var(--input-border-color)',
                                                borderColor: 'var(--input-border-color)',
                                                borderRadius: '10px',
                                                boxSizing: 'border-box',
                                                height: '50px',
                                                textAlign: 'left',
                                                '&:hover': {
                                                    borderColor: 'var(--input-border-color)'
                                                }
                                            }),
                                            placeholder: (baseStyles) => ({
                                                ...baseStyles,
                                                color: 'var(--border-color)'
                                            }),
                                            indicatorSeparator: (baseStyles) => ({
                                                display: 'none'
                                            }),
                                            container: (baseStyles) => ({
                                                ...baseStyles,
                                                width: '100%'
                                            }),
                                            dropdownIndicator: (baseStyles) => ({
                                                ...baseStyles,
                                                '& svg': {
                                                    fill: '#000'
                                                }
                                            })
                                        }}
                                        value={props.form3Details.channel}
                                        // onBlur={getFormErrors}
                                        // defaultValue={props.form3Details.channel}
                                        onChange={(value) => {
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                channel: value
                                            }))
                                        }}
                                    />
                                    {
                                        form3Errors.channel ? <span className='error-msg'>Please select channel</span> : null
                                    }
                                </div> : null
                            }{
                                tabNew[activeTab].includes(2) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label">Invoice Number<span className='text-danger'>*</span></label>
                                    <input className={`did-floating-input ${form3Errors.invoice ? 'border-error' : ''}`} type="text"
                                        value={props.form3Details.invoice || ''}
                                        // onBlur={getFormErrors}
                                        placeholder="Enter invoice number"
                                        onChange={(event) => {
                                            event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                invoice: event.target.value
                                            }))
                                        }} />
                                    {
                                        form3Errors.invoice ? <span className='error-msg'>Please enter invoice number</span> : null
                                    }
                                </div> : null
                            }

                            {
                                tabNew[activeTab].includes(19) ? <div className="did-floating-label-content position-relative">
                                    <label className="did-floating-label"
                                        style={{
                                            left: '54px'
                                        }}>Enter Invoice Value<span className='text-danger'>*</span></label>
                                    <span id='price' className={`${form3Errors.invoiceVal ? 'border-error' : ''} text-dark`}>₹</span>
                                    <input className={`did-floating-input ${form3Errors.invoiceVal ? 'border-error' : ''}`}
                                        type="text" placeholder="Enter Invoice Number"
                                        value={props.form3Details.invoiceVal || ''}
                                        // onBlur={getFormErrors}
                                        style={{
                                            paddingLeft: '58px'
                                        }}
                                        onChange={(event) => {
                                            event.persist();
                                            const value = event.target.value;
                                            if (/^[0-9]*$/.test(value)) {
                                                props.setForm3DetailsHandler((prevState) => ({
                                                    ...prevState,
                                                    invoiceVal: value
                                                }))
                                            }
                                        }} />
                                    {
                                        form3Errors.invoiceVal ? <span className='error-msg'>Please enter correct invoice value</span> : null
                                    }
                                </div> : null
                            }
                            {
                                tabNew[activeTab].includes(20) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label">Invoice Date<span className='text-danger'>*</span></label>
                                    <DatePicker placeholderText="Select invoice date"
                                        dateFormat="dd/MM/yyyy"
                                        selected={props.form3Details.invoiceDate || ''}
                                        maxDate={new Date()}
                                        onChange={(date) => {
                                            // event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                invoiceDate: date
                                            }))
                                        }}
                                        className={`did-floating-input ${form3Errors.invoiceDate ? 'border-error' : ''}`} />
                                    <span id='calendar'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.78049 1.68293C5.78049 1.30576 5.47474 1 5.09756 1C4.72039 1 4.41463 1.30576 4.41463 1.68293V2.02849C4.07594 2.03379 3.77499 2.04591 3.50991 2.0736C3.0186 2.12494 2.5732 2.23576 2.17709 2.5099C1.90684 2.69695 1.67256 2.93123 1.48551 3.20148C1.21137 3.59759 1.10055 4.04299 1.04922 4.5343C1.00413 4.96577 1.00034 5.49229 1.00003 6.12195L1 6.22673C1 6.25061 1 6.27463 1 6.2988V10.2677C0.99998 11.1925 0.99996 11.955 1.0811 12.5586C1.16629 13.1922 1.35203 13.7518 1.8001 14.1999C2.24817 14.648 2.80778 14.8337 3.44142 14.9189C4.04496 15.0001 4.80752 15 5.73227 15H9.9262C10.8509 15 11.6136 15.0001 12.2171 14.9189C12.8508 14.8337 13.4104 14.648 13.8584 14.1999C14.3065 13.7518 14.4922 13.1922 14.5775 12.5586C14.6586 11.955 14.6585 11.1925 14.6585 10.2677V6.2988C14.6585 6.27792 14.6585 6.25709 14.6585 6.23643V6.12195C14.6582 5.49229 14.6544 4.96577 14.6093 4.5343C14.558 4.04299 14.4472 3.59759 14.173 3.20148C13.986 2.93123 13.7517 2.69695 13.4814 2.5099C13.0853 2.23576 12.6399 2.12494 12.1486 2.0736C11.8835 2.04591 11.5826 2.03379 11.2439 2.02849V1.68293C11.2439 1.30576 10.9382 1 10.561 1C10.1838 1 9.87805 1.30576 9.87805 1.68293V2.02439H5.78049V1.68293ZM13.2926 6.12195C13.2921 5.48238 13.2878 5.03001 13.2509 4.67624C13.2111 4.29632 13.1399 4.10881 13.0499 3.97879C12.9564 3.84367 12.8393 3.72652 12.7041 3.633C12.5741 3.54301 12.3866 3.47176 12.0067 3.43206C11.7943 3.40988 11.5464 3.39946 11.2439 3.39456V3.73171C11.2439 4.10887 10.9382 4.41463 10.561 4.41463C10.1838 4.41463 9.87805 4.10887 9.87805 3.73171V3.39024H5.78049V3.73171C5.78049 4.10887 5.47474 4.41463 5.09756 4.41463C4.72039 4.41463 4.41463 4.10887 4.41463 3.73171V3.39456C4.11207 3.39946 3.8642 3.40988 3.65185 3.43206C3.27193 3.47176 3.08442 3.54301 2.9544 3.633C2.81928 3.72652 2.70213 3.84367 2.60861 3.97879C2.51863 4.10881 2.44738 4.29632 2.40768 4.67624C2.37071 5.03001 2.36641 5.48238 2.36592 6.12195H13.2926ZM2.36585 7.4878V10.2195C2.36585 11.2046 2.36731 11.8747 2.43478 12.3766C2.49961 12.8588 2.61391 13.0821 2.76591 13.2341C2.91791 13.3861 3.14124 13.5004 3.62342 13.5652C4.12524 13.6327 4.79538 13.6341 5.78049 13.6341H9.87805C10.8632 13.6341 11.5333 13.6327 12.0351 13.5652C12.5173 13.5004 12.7406 13.3861 12.8926 13.2341C13.0446 13.0821 13.159 12.8588 13.2238 12.3766C13.2912 11.8747 13.2927 11.2046 13.2927 10.2195V7.4878H2.36585Z" fill="#FF8300" />
                                        </svg>
                                    </span>
                                    {
                                        form3Errors.invoiceDate ? <span className='error-msg'>Please select invoice date</span> : null
                                    }
                                </div> : null
                            }
                            {
                                tabNew[activeTab].includes(10) ? <div className="did-floating-label-content position-relative">
                                    <label className="did-floating-label">Order Purchase date<span className='text-danger'>*</span></label>
                                    <DatePicker placeholderText="Select order purchase date"
                                        dateFormat="dd/MM/yyyy"
                                        selected={props.form3Details.orderDate || ''}
                                        maxDate={new Date()}
                                        onChange={(date) => {
                                            // event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                orderDate: date
                                            }))
                                        }}
                                        className={`did-floating-input ${form3Errors.orderDate ? 'border-error' : ''}`} />
                                    <span id='calendar'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.78049 1.68293C5.78049 1.30576 5.47474 1 5.09756 1C4.72039 1 4.41463 1.30576 4.41463 1.68293V2.02849C4.07594 2.03379 3.77499 2.04591 3.50991 2.0736C3.0186 2.12494 2.5732 2.23576 2.17709 2.5099C1.90684 2.69695 1.67256 2.93123 1.48551 3.20148C1.21137 3.59759 1.10055 4.04299 1.04922 4.5343C1.00413 4.96577 1.00034 5.49229 1.00003 6.12195L1 6.22673C1 6.25061 1 6.27463 1 6.2988V10.2677C0.99998 11.1925 0.99996 11.955 1.0811 12.5586C1.16629 13.1922 1.35203 13.7518 1.8001 14.1999C2.24817 14.648 2.80778 14.8337 3.44142 14.9189C4.04496 15.0001 4.80752 15 5.73227 15H9.9262C10.8509 15 11.6136 15.0001 12.2171 14.9189C12.8508 14.8337 13.4104 14.648 13.8584 14.1999C14.3065 13.7518 14.4922 13.1922 14.5775 12.5586C14.6586 11.955 14.6585 11.1925 14.6585 10.2677V6.2988C14.6585 6.27792 14.6585 6.25709 14.6585 6.23643V6.12195C14.6582 5.49229 14.6544 4.96577 14.6093 4.5343C14.558 4.04299 14.4472 3.59759 14.173 3.20148C13.986 2.93123 13.7517 2.69695 13.4814 2.5099C13.0853 2.23576 12.6399 2.12494 12.1486 2.0736C11.8835 2.04591 11.5826 2.03379 11.2439 2.02849V1.68293C11.2439 1.30576 10.9382 1 10.561 1C10.1838 1 9.87805 1.30576 9.87805 1.68293V2.02439H5.78049V1.68293ZM13.2926 6.12195C13.2921 5.48238 13.2878 5.03001 13.2509 4.67624C13.2111 4.29632 13.1399 4.10881 13.0499 3.97879C12.9564 3.84367 12.8393 3.72652 12.7041 3.633C12.5741 3.54301 12.3866 3.47176 12.0067 3.43206C11.7943 3.40988 11.5464 3.39946 11.2439 3.39456V3.73171C11.2439 4.10887 10.9382 4.41463 10.561 4.41463C10.1838 4.41463 9.87805 4.10887 9.87805 3.73171V3.39024H5.78049V3.73171C5.78049 4.10887 5.47474 4.41463 5.09756 4.41463C4.72039 4.41463 4.41463 4.10887 4.41463 3.73171V3.39456C4.11207 3.39946 3.8642 3.40988 3.65185 3.43206C3.27193 3.47176 3.08442 3.54301 2.9544 3.633C2.81928 3.72652 2.70213 3.84367 2.60861 3.97879C2.51863 4.10881 2.44738 4.29632 2.40768 4.67624C2.37071 5.03001 2.36641 5.48238 2.36592 6.12195H13.2926ZM2.36585 7.4878V10.2195C2.36585 11.2046 2.36731 11.8747 2.43478 12.3766C2.49961 12.8588 2.61391 13.0821 2.76591 13.2341C2.91791 13.3861 3.14124 13.5004 3.62342 13.5652C4.12524 13.6327 4.79538 13.6341 5.78049 13.6341H9.87805C10.8632 13.6341 11.5333 13.6327 12.0351 13.5652C12.5173 13.5004 12.7406 13.3861 12.8926 13.2341C13.0446 13.0821 13.159 12.8588 13.2238 12.3766C13.2912 11.8747 13.2927 11.2046 13.2927 10.2195V7.4878H2.36585Z" fill="#FF8300" />
                                        </svg>
                                    </span>
                                    {
                                        form3Errors.orderDate ? <span className='error-msg'>Please enter order purchase date</span> : null
                                    }
                                </div> : null
                            }
                            {
                                tabNew[activeTab].includes(11) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label">Delivery Date</label>
                                    <DatePicker placeholderText="Select delivery date"
                                        dateFormat="dd/MM/yyyy"
                                        selected={props.form3Details.deliveryDate || ''}
                                        maxDate={new Date()}
                                        onChange={(date) => {
                                            // event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                deliveryDate: date
                                            }))
                                        }}
                                        className={`did-floating-input`} />
                                    <span id='calendar'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.78049 1.68293C5.78049 1.30576 5.47474 1 5.09756 1C4.72039 1 4.41463 1.30576 4.41463 1.68293V2.02849C4.07594 2.03379 3.77499 2.04591 3.50991 2.0736C3.0186 2.12494 2.5732 2.23576 2.17709 2.5099C1.90684 2.69695 1.67256 2.93123 1.48551 3.20148C1.21137 3.59759 1.10055 4.04299 1.04922 4.5343C1.00413 4.96577 1.00034 5.49229 1.00003 6.12195L1 6.22673C1 6.25061 1 6.27463 1 6.2988V10.2677C0.99998 11.1925 0.99996 11.955 1.0811 12.5586C1.16629 13.1922 1.35203 13.7518 1.8001 14.1999C2.24817 14.648 2.80778 14.8337 3.44142 14.9189C4.04496 15.0001 4.80752 15 5.73227 15H9.9262C10.8509 15 11.6136 15.0001 12.2171 14.9189C12.8508 14.8337 13.4104 14.648 13.8584 14.1999C14.3065 13.7518 14.4922 13.1922 14.5775 12.5586C14.6586 11.955 14.6585 11.1925 14.6585 10.2677V6.2988C14.6585 6.27792 14.6585 6.25709 14.6585 6.23643V6.12195C14.6582 5.49229 14.6544 4.96577 14.6093 4.5343C14.558 4.04299 14.4472 3.59759 14.173 3.20148C13.986 2.93123 13.7517 2.69695 13.4814 2.5099C13.0853 2.23576 12.6399 2.12494 12.1486 2.0736C11.8835 2.04591 11.5826 2.03379 11.2439 2.02849V1.68293C11.2439 1.30576 10.9382 1 10.561 1C10.1838 1 9.87805 1.30576 9.87805 1.68293V2.02439H5.78049V1.68293ZM13.2926 6.12195C13.2921 5.48238 13.2878 5.03001 13.2509 4.67624C13.2111 4.29632 13.1399 4.10881 13.0499 3.97879C12.9564 3.84367 12.8393 3.72652 12.7041 3.633C12.5741 3.54301 12.3866 3.47176 12.0067 3.43206C11.7943 3.40988 11.5464 3.39946 11.2439 3.39456V3.73171C11.2439 4.10887 10.9382 4.41463 10.561 4.41463C10.1838 4.41463 9.87805 4.10887 9.87805 3.73171V3.39024H5.78049V3.73171C5.78049 4.10887 5.47474 4.41463 5.09756 4.41463C4.72039 4.41463 4.41463 4.10887 4.41463 3.73171V3.39456C4.11207 3.39946 3.8642 3.40988 3.65185 3.43206C3.27193 3.47176 3.08442 3.54301 2.9544 3.633C2.81928 3.72652 2.70213 3.84367 2.60861 3.97879C2.51863 4.10881 2.44738 4.29632 2.40768 4.67624C2.37071 5.03001 2.36641 5.48238 2.36592 6.12195H13.2926ZM2.36585 7.4878V10.2195C2.36585 11.2046 2.36731 11.8747 2.43478 12.3766C2.49961 12.8588 2.61391 13.0821 2.76591 13.2341C2.91791 13.3861 3.14124 13.5004 3.62342 13.5652C4.12524 13.6327 4.79538 13.6341 5.78049 13.6341H9.87805C10.8632 13.6341 11.5333 13.6327 12.0351 13.5652C12.5173 13.5004 12.7406 13.3861 12.8926 13.2341C13.0446 13.0821 13.159 12.8588 13.2238 12.3766C13.2912 11.8747 13.2927 11.2046 13.2927 10.2195V7.4878H2.36585Z" fill="#FF8300" />
                                        </svg>
                                    </span>
                                </div> : null
                            }
                            {
                                tabNew[activeTab].includes(18) ? <div
                                    className='position-relative upload-wrapper'>
                                    <label className={`file-label`} htmlFor="invoice-upload">Upload Invoice<span className='text-danger'>*</span></label>
                                    <div className={`form-input-group position-relative  ${form3Errors.invoiceDetails ? 'border-error' : ''}`}>
                                        <span className='centered'>Click to upload</span>
                                        <input
                                            type="file"
                                            name='invoice-upload'
                                            id='invoice-upload'
                                            onChange={(event) => {
                                                event.persist();
                                                fileUploadHandler(event, 'invoice');
                                                setIsCTADisabled(prevState => ({ ...prevState, purchaseDetailsCTA: false }))
                                            }}
                                            accept='image/*, application/*' />
                                        <svg className='centered' xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                            <path d="M15 8.31843C15 8.10318 14.9122 7.89675 14.7559 7.74455C14.5996 7.59234 14.3877 7.50684 14.1667 7.50684C13.9457 7.50684 13.7337 7.59234 13.5774 7.74455C13.4211 7.89675 13.3333 8.10318 13.3333 8.31843V11.0237C13.3333 11.3825 13.187 11.7265 12.9265 11.9802C12.6661 12.2339 12.3128 12.3764 11.9444 12.3764H3.05556C2.6872 12.3764 2.33393 12.2339 2.07346 11.9802C1.813 11.7265 1.66667 11.3825 1.66667 11.0237V8.31843C1.66667 8.10318 1.57887 7.89675 1.42259 7.74455C1.26631 7.59234 1.05435 7.50684 0.833333 7.50684C0.61232 7.50684 0.400358 7.59234 0.244078 7.74455C0.0877973 7.89675 0 8.10318 0 8.31843V11.0237C0 11.813 0.321924 12.5699 0.894951 13.128C1.46798 13.6861 2.24517 13.9996 3.05556 13.9996H11.9444C12.7548 13.9996 13.532 13.6861 14.105 13.128C14.6781 12.5699 15 11.813 15 11.0237V8.31843Z" fill="#FF8300" />
                                            <path d="M7.49871 10.8727C7.71973 10.8727 7.93169 10.7871 8.08797 10.6349C8.24425 10.4827 8.33205 10.2763 8.33205 10.0611V2.63768L10.4848 4.5314C10.6512 4.65668 10.8601 4.71604 11.0696 4.69757C11.2791 4.67911 11.4736 4.58418 11.6142 4.43184C11.7548 4.27949 11.8311 4.081 11.8277 3.87619C11.8243 3.67137 11.7415 3.47538 11.5959 3.32754L8.05427 0.205604L8.00427 0.170435L7.94316 0.12715L7.86816 0.08657L7.80427 0.0568119L7.71538 0.0297586L7.65149 0.0135269C7.60384 0.00493611 7.55551 0.000409786 7.50705 0H7.49871C7.45025 0.000409786 7.40192 0.00493611 7.35427 0.0135269L7.29038 0.0297586L7.20149 0.0568119L7.1376 0.08657L7.0626 0.12715L7.00149 0.170435L6.94316 0.205604L3.39594 3.33024C3.25036 3.47809 3.16756 3.67408 3.16417 3.87889C3.16078 4.08371 3.23703 4.2822 3.37764 4.43454C3.51824 4.58688 3.7128 4.68181 3.92227 4.70028C4.13174 4.71874 4.34064 4.65938 4.50705 4.53411L6.65983 2.64039V10.0611C6.65982 10.1681 6.68156 10.2741 6.72379 10.3729C6.76601 10.4717 6.82789 10.5614 6.90586 10.6369C6.98384 10.7123 7.07636 10.772 7.1781 10.8124C7.27985 10.8529 7.38881 10.8734 7.49871 10.8727Z" fill="#FF8300" />
                                        </svg>
                                    </div>
                                    {
                                        form3Errors.invoiceDetails ? <span className='error-msg'>Please upload file here</span> : null
                                    }
                                    <span className='text-brand d-flex cursor-text'>Image size should be less than 5MB</span>
                                    {
                                        props.form3Details.invoiceDetails ?
                                            <div className='file-box-wrapper'>
                                                {getHTML()}
                                            </div> : null
                                    }
                                </div> : null
                            }
                            <div className='d-grid' id="info-wrapper">
                                <div className='bg-grey'>
                                    <span>How can I get my invoice from Amazon?</span>
                                    <div className='item'>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-1.png" alt="image-1" />
                                            <span>Login into Amazon</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-2.png" alt="image-2" />
                                            <span>Go to ‘Returns & Orders</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-3.png" alt="image-3" />
                                            <span>Click Invoice Dropdown</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-4.png" alt="image-4" />
                                            <span>Download Invoice 1</span>
                                        </div>
                                    </div>
                                </div>

                                <div className='bg-grey'>
                                    <span>How can I get my invoice from Flipkart?</span>
                                    <div className='item'>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-5.png" alt="image-5" />
                                            <span>Login into Filpkart</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-6.png" alt="image-6" />
                                            <span>Go to ‘Orders’ in profile</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-7.png" alt="image-7" />
                                            <span>Select product from order list</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-8.png" alt="image-8" />
                                            <span>Click ‘Download Invoice’</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type='button' className='btn btn-outline mr-0 ml-auto' onClick={() => goToNextStep('prev', '', '', 'product details')}>Previous Section</button>
                            <button type='button' disabled={isCTADisabled?.purchaseDetailsCTA} className='btn btn-outline ml-0 mr-auto' onClick={() => goToNextStep('next', 'purchase details', 'issue details', '')}>Next Section</button>
                        </>
                    case 'issue details':
                        return <>
                            {
                                tabNew[activeTab].includes(8) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label">Problem</label>
                                    <Select
                                        className="basic-single "
                                        classNamePrefix="select"
                                        isSearchable
                                        name="main-problem"
                                        components={{ DropdownIndicator }}
                                        placeholder="Select Problem"
                                        options={mainProblemList}
                                        classNames={{
                                            control: (state) =>
                                                form3Errors.mainProblem ? 'border-error' : '',
                                        }}
                                        styles={{
                                            container: (baseStyles) => ({
                                                ...baseStyles,
                                                width: '100%'
                                            }),
                                            menu: (baseStyles) => ({
                                                ...baseStyles,
                                                zIndex: 2,
                                            }),
                                            menuList: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            singleValue: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                fontSize: '16px',
                                                background: '#fff',
                                                border: '1px solid  var(--input-border-color)',
                                                borderColor: ' var(--input-border-color)',
                                                borderRadius: '10px',
                                                boxSizing: 'border-box',
                                                height: '50px',
                                                textAlign: 'left',
                                                minWidth: '290px',
                                                '&:hover': {
                                                    borderColor: ' var(--input-border-color)'
                                                }
                                            }),
                                            placeholder: (baseStyles) => ({
                                                ...baseStyles,
                                                color: 'var(--border-color)'
                                            }),
                                            indicatorSeparator: (baseStyles) => ({
                                                display: 'none'
                                            }),
                                            dropdownIndicator: (baseStyles) => ({
                                                ...baseStyles,
                                                '& svg': {
                                                    fill: '#000'
                                                }
                                            })
                                        }}
                                        value={props.form3Details.mainProblem}
                                        // onBlur={getFormErrors}
                                        // defaultValue={mainProblemList[0]}
                                        onChange={(value) => {
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                mainProblem: value
                                            }));
                                            if (props.form1Details.type?.value !== 'delivery'
                                                || props.form1Details.type?.value !== 'items_missing'
                                                || props.form1Details.type?.value !== 'poor_quality'
                                                || props.form1Details.type?.value !== 'wrong_items'
                                            ) getSubProblemList(props.form3Details.category.value, value.value.toString());
                                        }}
                                    />
                                </div> : null
                            }

                            {
                                tabNew[activeTab].includes(9) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label">Sub Problem</label>
                                    <Select
                                        className="basic-single "
                                        classNamePrefix="select"
                                        isSearchable
                                        name="sub-problem"
                                        components={{ DropdownIndicator }}
                                        placeholder="Sub Problem"
                                        options={subProblemList}
                                        classNames={{
                                            control: (state) =>
                                                form3Errors.subProblem ? 'border-error' : '',
                                        }}
                                        styles={{
                                            container: (baseStyles) => ({
                                                ...baseStyles,
                                                width: '100%'
                                            }),
                                            menu: (baseStyles) => ({
                                                ...baseStyles,
                                                zIndex: 2,
                                            }),
                                            menuList: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            indicatorSeparator: (baseStyles) => ({
                                                display: 'none'
                                            }),
                                            singleValue: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                fontSize: '16px',
                                                background: '#fff',
                                                border: '1px solid var(--input-border-color)',
                                                borderColor: ' var(--input-border-color)',
                                                borderRadius: '10px',
                                                boxSizing: 'border-box',
                                                height: '50px',
                                                minWidth: '290px',
                                                textAlign: 'left',
                                                '&:hover': {
                                                    borderColor: ' var(--input-border-color)'
                                                }
                                            }),
                                            placeholder: (baseStyles) => ({
                                                ...baseStyles,
                                                color: 'var(--border-color)'
                                            }),
                                            dropdownIndicator: (baseStyles) => ({
                                                ...baseStyles,
                                                '& svg': {
                                                    fill: '#000'
                                                }
                                            })
                                        }}
                                        value={props.form3Details.subProblem}
                                        // onBlur={getFormErrors}
                                        // defaultValue={subProblemList[0]}
                                        onChange={(value) => {
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                subProblem: value
                                            }));
                                        }}
                                    />
                                </div> : null
                            }

                            {
                                commsList && commsList.subProblemInstruction ?
                                    < p id='commsWrapper' dangerouslySetInnerHTML={{ __html: commsList.subProblemInstruction }}></p>
                                    : null
                            }


                            {
                                tabNew[activeTab].includes(3) ? <div className='bg-grey'>
                                    <div className='file-upload-wrapper w-100'>
                                        <div className="form-input-group position-relative">
                                            <label className='file-label' htmlFor="images-upload">Upload Images{props.form1Details.type?.value !== 'air_bike_installation' ? <span className='text-danger'>*</span> : null}</label>
                                            <div className={`position-relative ${form3Errors.images ? 'border-error' : ''}`}>
                                                <span>Click to upload</span>
                                                <input
                                                    type="file"
                                                    name='images-upload'
                                                    id='images-upload'
                                                    onChange={(event) => {
                                                        event.persist();
                                                        fileUploadHandler(event, 'images');
                                                    }}
                                                    multiple
                                                    accept='image/*' />

                                                <span id='calendar'>
                                                    <svg className='centered' xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                        <path d="M15 8.31843C15 8.10318 14.9122 7.89675 14.7559 7.74455C14.5996 7.59234 14.3877 7.50684 14.1667 7.50684C13.9457 7.50684 13.7337 7.59234 13.5774 7.74455C13.4211 7.89675 13.3333 8.10318 13.3333 8.31843V11.0237C13.3333 11.3825 13.187 11.7265 12.9265 11.9802C12.6661 12.2339 12.3128 12.3764 11.9444 12.3764H3.05556C2.6872 12.3764 2.33393 12.2339 2.07346 11.9802C1.813 11.7265 1.66667 11.3825 1.66667 11.0237V8.31843C1.66667 8.10318 1.57887 7.89675 1.42259 7.74455C1.26631 7.59234 1.05435 7.50684 0.833333 7.50684C0.61232 7.50684 0.400358 7.59234 0.244078 7.74455C0.0877973 7.89675 0 8.10318 0 8.31843V11.0237C0 11.813 0.321924 12.5699 0.894951 13.128C1.46798 13.6861 2.24517 13.9996 3.05556 13.9996H11.9444C12.7548 13.9996 13.532 13.6861 14.105 13.128C14.6781 12.5699 15 11.813 15 11.0237V8.31843Z" fill="#FF8300" />
                                                        <path d="M7.49871 10.8727C7.71973 10.8727 7.93169 10.7871 8.08797 10.6349C8.24425 10.4827 8.33205 10.2763 8.33205 10.0611V2.63768L10.4848 4.5314C10.6512 4.65668 10.8601 4.71604 11.0696 4.69757C11.2791 4.67911 11.4736 4.58418 11.6142 4.43184C11.7548 4.27949 11.8311 4.081 11.8277 3.87619C11.8243 3.67137 11.7415 3.47538 11.5959 3.32754L8.05427 0.205604L8.00427 0.170435L7.94316 0.12715L7.86816 0.08657L7.80427 0.0568119L7.71538 0.0297586L7.65149 0.0135269C7.60384 0.00493611 7.55551 0.000409786 7.50705 0H7.49871C7.45025 0.000409786 7.40192 0.00493611 7.35427 0.0135269L7.29038 0.0297586L7.20149 0.0568119L7.1376 0.08657L7.0626 0.12715L7.00149 0.170435L6.94316 0.205604L3.39594 3.33024C3.25036 3.47809 3.16756 3.67408 3.16417 3.87889C3.16078 4.08371 3.23703 4.2822 3.37764 4.43454C3.51824 4.58688 3.7128 4.68181 3.92227 4.70028C4.13174 4.71874 4.34064 4.65938 4.50705 4.53411L6.65983 2.64039V10.0611C6.65982 10.1681 6.68156 10.2741 6.72379 10.3729C6.76601 10.4717 6.82789 10.5614 6.90586 10.6369C6.98384 10.7123 7.07636 10.772 7.1781 10.8124C7.27985 10.8529 7.38881 10.8734 7.49871 10.8727Z" fill="#FF8300" />
                                                    </svg>
                                                </span>
                                            </div>
                                            {
                                                form3Errors.images ? <span className='error-msg'>Please upload file here</span> : null
                                            }
                                            <span className='text-brand d-flex cursor-text'>Image size should be less than 5MB</span>
                                        </div>
                                    </div>
                                    <div className='w-70 d-none'>
                                        <span>Sample Images</span>
                                        <div className='d-flex justify-content-around'>
                                            <div className='d-inline-flex flex-column'>
                                                <img src='https://img.beatxp.com/prod/complaint/info-img-9.png' alt='img-9' />

                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="10" fill="#00A600" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M13.8175 8.13501L9.32747 12.805C9.07747 13.065 8.6775 13.065 8.4275 12.805L6.1875 10.455C5.9375 10.195 5.9375 9.77504 6.1875 9.51499C6.4375 9.25501 6.83747 9.25501 7.08747 9.51499L8.88747 11.395L12.9275 7.19499C13.1775 6.935 13.5774 6.935 13.8274 7.19499C14.0675 7.45497 14.0675 7.87502 13.8175 8.13501Z" fill="white" />
                                                </svg>

                                                <span>Correct Image</span>
                                            </div>
                                            <div className='d-inline-flex flex-column'>
                                                <img src='https://img.beatxp.com/prod/complaint/info-img-10.png' alt='img-10' />

                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="10" fill="#FF0000" />
                                                    <path d="M12.843 7.15724C12.6336 6.94784 12.2942 6.94784 12.0848 7.15724L10 9.24187L7.91518 7.15705C7.70578 6.94765 7.36644 6.94765 7.15705 7.15705C6.94765 7.36644 6.94765 7.70578 7.15705 7.91518L9.24187 10L7.15705 12.0848C6.94765 12.2942 6.94765 12.6336 7.15705 12.843C7.36644 13.0523 7.70578 13.0523 7.91518 12.843L10 10.7581L12.0848 12.843C12.2942 13.0523 12.6336 13.0523 12.843 12.843C13.0523 12.6336 13.0523 12.2942 12.843 12.0848L10.7581 10L12.843 7.91518C13.0523 7.70578 13.0523 7.36644 12.843 7.15705V7.15724Z" fill="white" />
                                                </svg>

                                                <span>Incorrect Image</span>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        props.form3Details.images && props.form3Details.images.length ?
                                            <div className='file-box-wrapper'>
                                                {
                                                    [...props.form3Details.images].map(item => (

                                                        <span className='file-box-image' key={item.name}
                                                            style={{
                                                                backgroundImage: `url(${URL.createObjectURL(item)})`
                                                            }}>
                                                            <button type='button'>
                                                                <span onClick={() => { setImgSrc({ type: 'img', src: item }); setShowImage(true) }}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M7.50026 5C6.39754 5 5.49991 5.89759 5.49991 6.99965C5.49991 8.10242 6.39754 9 7.50026 9C8.60299 9 9.50061 8.10242 9.50061 6.99965C9.50061 5.89759 8.60299 5 7.50026 5ZM7.49947 10C5.84276 10 4.5 8.65721 4.5 6.99974C4.5 5.3428 5.84276 4 7.49947 4C9.15619 4 10.4989 5.3428 10.4989 6.99974C10.4989 8.65721 9.15619 10 7.49947 10ZM7.5 12C10.4788 12 13.3987 9.31873 13.976 6.9998C13.3987 4.68119 10.4787 2 7.5 2C4.52103 2 1.60131 4.68101 1.02397 6.9998C1.60127 9.31891 4.52095 12 7.5 12ZM0 6.99977C0.416593 4.85706 3.35733 1 7.5 1C11.6422 1 14.5834 4.85706 15 6.99977C14.5834 9.14294 11.6422 13 7.5 13C3.35733 13 0.416593 9.14294 0 6.99977Z" fill="white" />
                                                                    </svg>
                                                                </span>
                                                                <span onClick={() => removeItem(item.name, 'images')}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                                                        <path d="M13.0256 2.15385H10.5329L10.2895 1.4761C10.0871 0.605231 9.38851 0 8.57723 0H5.98687C5.17631 0 4.47703 0.605231 4.27456 1.4761L4.03118 2.15385H1.53846C1.24123 2.15385 1 2.39508 1 2.69231C1 2.98954 1.24123 3.23077 1.53846 3.23077H2.4359V12.0256C2.4359 13.1148 3.32113 14 4.41026 14H10.1538C11.243 14 12.1282 13.1148 12.1282 12.0256V3.23077H13.0256C13.3229 3.23077 13.5641 2.98954 13.5641 2.69231C13.5641 2.39508 13.3229 2.15385 13.0256 2.15385ZM5.29979 1.8078L5.31918 1.73887C5.40246 1.34903 5.67744 1.07692 5.98687 1.07692H8.57723C8.88667 1.07692 9.16092 1.34903 9.24492 1.73887L9.38851 2.15385H5.17559L5.29979 1.8078ZM11.0513 12.0256C11.0513 12.5203 10.6485 12.9231 10.1538 12.9231H4.41026C3.91559 12.9231 3.51282 12.5203 3.51282 12.0256V3.23077H11.0513V12.0256ZM5.30769 9.87179V6.28205C5.30769 5.98482 5.54892 5.74359 5.84615 5.74359C6.14338 5.74359 6.38461 5.98482 6.38461 6.28205V9.87179C6.38461 10.169 6.14338 10.4103 5.84615 10.4103C5.54892 10.4103 5.30769 10.169 5.30769 9.87179ZM8.17949 9.87179V6.28205C8.17949 5.98482 8.42072 5.74359 8.71795 5.74359C9.01518 5.74359 9.25641 5.98482 9.25641 6.28205V9.87179C9.25641 10.169 9.01518 10.4103 8.71795 10.4103C8.42072 10.4103 8.17949 10.169 8.17949 9.87179Z" fill="white" />
                                                                    </svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                    ))
                                                }
                                            </div> : null
                                    }
                                    {/* <span className="note">Note: Please consider sample images before uploading your image.</span> */}
                                </div> : null
                            }
                            {
                                tabNew[activeTab].includes(14) ? <div className='bg-grey'>
                                    <div className="form-input-group position-relative">
                                        <label className='file-label' htmlFor="video-upload">Upload Videos{props.form1Details.type?.value !== 'air_bike_installation' ? <span className='text-danger'>*</span> : null}</label>
                                        <div className={`position-relative ${form3Errors.video ? 'border-error' : ''}`}>
                                            <span>Click to upload</span>
                                            <input type="file" name='video-upload' id='video-upload'
                                                onInput={(event) => {
                                                    event.persist();
                                                    fileUploadHandler(event, 'video');
                                                    setIsCTADisabled(prevState => ({ ...prevState, issueDetailsCTA: false }))
                                                }}
                                                accept='video/*' />

                                            <span id='calendar'>
                                                <svg className='centered' xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                    <path d="M15 8.31843C15 8.10318 14.9122 7.89675 14.7559 7.74455C14.5996 7.59234 14.3877 7.50684 14.1667 7.50684C13.9457 7.50684 13.7337 7.59234 13.5774 7.74455C13.4211 7.89675 13.3333 8.10318 13.3333 8.31843V11.0237C13.3333 11.3825 13.187 11.7265 12.9265 11.9802C12.6661 12.2339 12.3128 12.3764 11.9444 12.3764H3.05556C2.6872 12.3764 2.33393 12.2339 2.07346 11.9802C1.813 11.7265 1.66667 11.3825 1.66667 11.0237V8.31843C1.66667 8.10318 1.57887 7.89675 1.42259 7.74455C1.26631 7.59234 1.05435 7.50684 0.833333 7.50684C0.61232 7.50684 0.400358 7.59234 0.244078 7.74455C0.0877973 7.89675 0 8.10318 0 8.31843V11.0237C0 11.813 0.321924 12.5699 0.894951 13.128C1.46798 13.6861 2.24517 13.9996 3.05556 13.9996H11.9444C12.7548 13.9996 13.532 13.6861 14.105 13.128C14.6781 12.5699 15 11.813 15 11.0237V8.31843Z" fill="#FF8300" />
                                                    <path d="M7.49871 10.8727C7.71973 10.8727 7.93169 10.7871 8.08797 10.6349C8.24425 10.4827 8.33205 10.2763 8.33205 10.0611V2.63768L10.4848 4.5314C10.6512 4.65668 10.8601 4.71604 11.0696 4.69757C11.2791 4.67911 11.4736 4.58418 11.6142 4.43184C11.7548 4.27949 11.8311 4.081 11.8277 3.87619C11.8243 3.67137 11.7415 3.47538 11.5959 3.32754L8.05427 0.205604L8.00427 0.170435L7.94316 0.12715L7.86816 0.08657L7.80427 0.0568119L7.71538 0.0297586L7.65149 0.0135269C7.60384 0.00493611 7.55551 0.000409786 7.50705 0H7.49871C7.45025 0.000409786 7.40192 0.00493611 7.35427 0.0135269L7.29038 0.0297586L7.20149 0.0568119L7.1376 0.08657L7.0626 0.12715L7.00149 0.170435L6.94316 0.205604L3.39594 3.33024C3.25036 3.47809 3.16756 3.67408 3.16417 3.87889C3.16078 4.08371 3.23703 4.2822 3.37764 4.43454C3.51824 4.58688 3.7128 4.68181 3.92227 4.70028C4.13174 4.71874 4.34064 4.65938 4.50705 4.53411L6.65983 2.64039V10.0611C6.65982 10.1681 6.68156 10.2741 6.72379 10.3729C6.76601 10.4717 6.82789 10.5614 6.90586 10.6369C6.98384 10.7123 7.07636 10.772 7.1781 10.8124C7.27985 10.8529 7.38881 10.8734 7.49871 10.8727Z" fill="#FF8300" />
                                                </svg>
                                            </span>
                                        </div>
                                        {
                                            form3Errors.video ? <span className='error-msg'>Please upload file here</span> : null
                                        }
                                        <span className='text-brand d-flex cursor-text'>Video size should be less than 50MB</span>
                                    </div>
                                    {
                                        props.form3Details.subProblem?.value === "Dead on Arrival ( Didn't Switch On)" ?
                                            <div className='w-70'>
                                                <span>Sample Video</span>
                                                <div className='d-flex justify-content-center'>
                                                    <div className='d-inline-flex flex-column sample-video-section' onClick={() => setPlayVideo(true)}>
                                                        <img src='https://img.beatxp.com/prod/saras/vid_1_thumb.png' />
                                                        <div className='thumbnail-overlay'></div>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M21 0C32.59 0 42 9.41 42 21C42 32.59 32.59 42 21 42C9.41 42 0 32.59 0 21C0 9.41 9.41 0 21 0ZM29.555 21.832L17.555 29.832C17.248 30.037 16.853 30.056 16.528 29.882C16.203 29.708 16 29.369 16 29V13C16 12.631 16.203 12.292 16.528 12.118C16.853 11.944 17.248 11.963 17.555 12.168L29.555 20.168C29.833 20.353 30 20.666 30 21C30 21.334 29.833 21.647 29.555 21.832Z" fill="white" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div> : null
                                    }
                                    {
                                        props.form3Details.video ?
                                            <div className='file-box-wrapper'>
                                                {
                                                    <span className='file-box w-100' key={props.form3Details.video.name}>
                                                        <span className='cursor-pointer' onClick={() => { setImgSrc({ src: props.form3Details.video, type: 'video' }); setShowImage(true) }}>
                                                            <svg className='mr-2' xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M1.23127 12.7945C2.87294 14.4018 5.5428 14.4018 7.18447 12.7945L15.1221 5.02289C16.2926 3.87684 16.2926 2.00559 15.1221 0.859541C13.9516 -0.286514 12.0403 -0.286514 10.8698 0.859541L2.93217 8.63114C2.2328 9.31588 2.2328 10.4444 2.93217 11.1291C3.63156 11.8139 4.78418 11.8139 5.48355 11.1291L12.2872 4.46778C12.4427 4.31976 12.5048 4.10123 12.4496 3.89588C12.3945 3.69052 12.2307 3.53014 12.0209 3.47614C11.8112 3.42213 11.588 3.48287 11.4368 3.6351L4.6331 10.2965C4.39016 10.5343 4.02558 10.5344 3.78264 10.2965C3.53971 10.0586 3.53971 9.70167 3.78264 9.4638L11.7203 1.6922C12.4344 0.993058 13.5576 0.993058 14.2717 1.69222C14.9857 2.39137 14.9857 3.49107 14.2716 4.19021L6.33402 11.9618C5.14877 13.1223 3.26695 13.1223 2.08172 11.9618C0.896489 10.8014 0.896489 8.95891 2.08172 7.79847L8.8854 1.1371C9.04109 0.989109 9.10328 0.770486 9.04816 0.565004C8.99303 0.359522 8.82913 0.199046 8.61926 0.145073C8.40939 0.0910999 8.18609 0.151999 8.03494 0.304433L1.23125 6.96579C-0.41042 8.57314 -0.41042 11.1871 1.23127 12.7945Z" fill="#6C6A6A" />
                                                            </svg>
                                                            {props.form3Details.video.name}
                                                        </span>
                                                        <button type='button' onClick={() => removeItem(props.form3Details.video.name, 'video')}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                <path d="M11.6859 0.314477C11.2671 -0.104315 10.5884 -0.104315 10.1696 0.314477L6 4.48373L1.83036 0.314094C1.41157 -0.104698 0.732886 -0.104698 0.314094 0.314094C-0.104698 0.732886 -0.104698 1.41157 0.314094 1.83036L4.48374 6L0.314094 10.1696C-0.104698 10.5884 -0.104698 11.2671 0.314094 11.6859C0.732886 12.1047 1.41157 12.1047 1.83036 11.6859L6 7.51627L10.1696 11.6859C10.5884 12.1047 11.2671 12.1047 11.6859 11.6859C12.1047 11.2671 12.1047 10.5884 11.6859 10.1696L7.51627 6L11.6859 1.83036C12.1047 1.41157 12.1047 0.732886 11.6859 0.314094V0.314477Z" fill="#FF8300" />
                                                            </svg>
                                                        </button>
                                                    </span>
                                                }
                                            </div> : null
                                    }
                                    <span className="note">Note: Please consider sample video and follow all steps before uploading your video.</span>
                                </div> : null
                            }

                            {
                                tabs[activeTab].includes(4) ? <div className="did-floating-label-content w-100 flex-basis-unset">
                                    <label className="did-floating-label">Remarks</label>
                                    <textarea className="did-floating-input" placeholder="Describe your problem in detail"
                                        value={props.form3Details.comments || ''}
                                        style={{
                                            height: '80px'
                                        }}
                                        onChange={(event) => {
                                            event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                comments: event.target.value
                                            }))
                                        }} />
                                </div> : null
                            }
                            <button type='button' className='btn btn-outline mr-0 ml-auto' onClick={() => goToNextStep('prev', '', '', 'product details')}>Previous Section</button>
                            <button type='button' disabled={isCTADisabled?.issueDetailsCTA} className='btn btn-outline ml-0 mr-auto' onClick={() => goToNextStep('next', 'issue details', 'pick-Up address')}>Next Section</button>

                        </>
                    case 'pick-Up address':
                        return <>
                            {
                                tabNew[activeTab].includes(16) ? <div className='w-100'>
                                    <div className='address-wrapper'>
                                        <div className="did-floating-label-content w-100">
                                            <label className="did-floating-label">Address</label>
                                            <input className={`did-floating-input ${form3Errors.pickupAddress ? 'border-error' : ''}`} type="text" placeholder="Enter your complete address"
                                                value={props.form3Details.address.address || ''}
                                                // onBlur={getFormErrors}
                                                name="address"
                                                maxLength={180}
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        address: { ...props.form3Details.address, address: event.target.value }
                                                    }));
                                                }} />
                                            {
                                                form3Errors.pickupAddress ? <span className='error-msg'>Please enter address</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id='pincode'>
                                            <label className="did-floating-label">Pincode</label>
                                            <input className={`did-floating-input ${form3Errors.pickupAddressPincode ? 'border-error' : ''}`} type="number" placeholder="Enter your pincode"
                                                value={props.form3Details.address.pincode || ''}
                                                // onBlur={getFormErrors}
                                                name="pincode"
                                                onChange={(event) => {
                                                    event.persist();
                                                    const val = event.target.value.toString().length > 6 ? event.target.value.slice(0, 6) : event.target.value;
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        address: { ...props.form3Details.address, pincode: val }
                                                    }));
                                                    getLocationDets(val, 'pickup');
                                                }} />
                                            {
                                                form3Errors.pickupAddressPincode ? <span className='error-msg'>Please enter pincode</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id='city'>
                                            <label className="did-floating-label">City</label>
                                            <input className={`did-floating-input ${form3Errors.pickupAddressCity ? 'border-error' : ''}`} type="text" placeholder="Enter your city"
                                                value={props.form3Details.address.city || ''}
                                                // onBlur={getFormErrors}
                                                name="city"
                                                maxLength={20}
                                                disabled={isFieldDisabled['pickup-city'] && props.form3Details.address.pincode}
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        address: { ...props.form3Details.address, city: event.target.value }
                                                    }));
                                                }} />
                                            {
                                                form3Errors.pickupAddressCity ? <span className='error-msg'>Please enter city</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id="state">
                                            <label className="did-floating-label">State</label>
                                            <input className={`did-floating-input ${form3Errors.pickupAddressState ? 'border-error' : ''}`} type="text" placeholder="Enter your state"
                                                value={props.form3Details.address.state || ''}
                                                // onBlur={getFormErrors}
                                                name="state"
                                                maxLength={20}
                                                disabled={isFieldDisabled['pickup-state'] && props.form3Details.address.pincode}
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        address: { ...props.form3Details.address, state: event.target.value }
                                                    }));
                                                }} />
                                            {
                                                form3Errors.pickupAddressState ? <span className='error-msg'>Please enter state</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id='landmark'>
                                            <label className="did-floating-label">Landmark</label>
                                            <input className={`did-floating-input ${form3Errors.pickupAddressLandmark ? 'border-error' : ''}`} type="text" placeholder="Enter landmark"
                                                value={props.form3Details.address.landmark || ''}
                                                // onBlur={getFormErrors}
                                                name="landmark"
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        address: { ...props.form3Details.address, landmark: event.target.value }
                                                    }));
                                                }} />
                                            {
                                                form3Errors.pickupAddressLandmark ? <span className='error-msg'>Please enter landmark</span> : null
                                            }
                                        </div>
                                    </div>
                                    <span className='d-block text-left'>
                                        <label className="checkbox-wrapper">
                                            Please tick if Delivery Address will be same as Pick-Up Address
                                            <input type="checkbox" ref={tickRef} />
                                            <span className="checkmark"></span>
                                        </label>
                                    </span>
                                    <button type='button' className='btn btn-outline mr-3 ml-auto' onClick={() => goToNextStep('prev', '', '', 'issue details')}>Previous Section</button>
                                    <button type='button' className='btn btn-outline ml-0 mr-auto' onClick={() => goToNextStep('next', 'pick-Up address', 'delivery address')}>Next Section</button>
                                </div> : null
                            }
                        </>
                    case 'delivery address':
                        return <>

                            {
                                tabNew[activeTab].includes(17) ? <div className='w-100'>
                                    <div className='address-wrapper'>
                                        <div className="did-floating-label-content w-100">
                                            <label className="did-floating-label">Address</label>
                                            <input className={`did-floating-input ${form3Errors.deliveryAddress ? 'border-error' : ''}`} type="text" placeholder="Enter your complete address"
                                                value={props.form3Details.deliveryAddress.address || ''}
                                                // onBlur={getFormErrors}
                                                name="address"
                                                maxLength={180}
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        deliveryAddress: { ...props.form3Details.deliveryAddress, address: event.target.value }
                                                    }));
                                                }} />{
                                                form3Errors.deliveryAddress ? <span className='error-msg'>Please enter address</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id='pincode'>
                                            <label className="did-floating-label">Pincode</label>
                                            <input className={`did-floating-input ${form3Errors.deliveryAddressPincode ? 'border-error' : ''}`} type="number" placeholder="Enter your pincode"
                                                value={props.form3Details.deliveryAddress.pincode || ''}
                                                // onBlur={getFormErrors}
                                                name="pincode"
                                                onChange={(event) => {
                                                    event.persist();
                                                    const val = event.target.value.toString().length > 6 ? event.target.value.slice(0, 6) : event.target.value;
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        deliveryAddress: { ...props.form3Details.deliveryAddress, pincode: val }
                                                    }));
                                                    getLocationDets(val, 'delivery');
                                                }
                                                } />{
                                                form3Errors.deliveryAddressPincode ? <span className='error-msg'>Please enter pincode</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id='city'>
                                            <label className="did-floating-label">City</label>
                                            <input className={`did-floating-input ${form3Errors.deliveryAddressCity ? 'border-error' : ''}`} type="text" placeholder="Enter your city"
                                                value={props.form3Details.deliveryAddress.city || ''}
                                                // onBlur={getFormErrors}
                                                name="city"
                                                maxLength={20}
                                                disabled={isFieldDisabled['delivery-city'] && props.form3Details.deliveryAddress.pincode}
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        deliveryAddress: { ...props.form3Details.deliveryAddress, city: event.target.value }
                                                    }));
                                                }} />{
                                                form3Errors.deliveryAddressCity ? <span className='error-msg'>Please enter city</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id="state">
                                            <label className="did-floating-label">State</label>
                                            <input className={`did-floating-input ${form3Errors.deliveryAddressState ? 'border-error' : ''}`} type="text" placeholder="Enter your state"
                                                value={props.form3Details.deliveryAddress.state || ''}
                                                // onBlur={getFormErrors}
                                                name="state"
                                                maxLength={20}
                                                disabled={isFieldDisabled['delivery-state'] && props.form3Details.deliveryAddress.pincode}
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        deliveryAddress: { ...props.form3Details.deliveryAddress, state: event.target.value }
                                                    }));
                                                }} />
                                            {
                                                form3Errors.deliveryAddressState ? <span className='error-msg'>Please enter state</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id='landmark'>
                                            <label className="did-floating-label">Landmark</label>
                                            <input className={`did-floating-input ${form3Errors.deliveryAddressLandmark ? 'border-error' : ''}`} type="text" placeholder="Enter landmark"
                                                value={props.form3Details.deliveryAddress.landmark || ''}
                                                // onBlur={getFormErrors}
                                                name="landmark"
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        deliveryAddress: { ...props.form3Details.deliveryAddress, landmark: event.target.value }
                                                    }));
                                                }
                                                } />
                                            {
                                                form3Errors.deliveryAddressLandmark ? <span className='error-msg'>Please enter landmark</span> : null
                                            }
                                        </div>
                                    </div>
                                    <button type='button' className='btn btn-outline mr-0 ml-auto' onClick={() => goToNextStep('prev', '', '', 'pick-Up address')}>Previous Section</button>
                                </div> : null
                            }
                            <button type='button' className='btn btn-brand text-white'
                                onClick={submitform}>Submit your complaint
                            </button>
                        </>
                }
                break;
            case 'air_bike_installation':
                switch (activeTab) {
                    case 'product details':
                        return <>
                            {
                                tabs[activeTab].includes(6) ?
                                    <div className="did-floating-label-content catName">
                                        <label className="did-floating-label">Product Category<span className='text-danger'>*</span></label>
                                        <Select
                                            className="basic-single w-100"
                                            classNamePrefix="select"
                                            isSearchable
                                            name="type"
                                            options={categoryList}
                                            isDisabled={isCatDisabled}
                                            components={{ DropdownIndicator }}
                                            placeholder="Select product category"
                                            classNames={{
                                                control: (state) =>
                                                    form3Errors.category ? 'border-error' : '',
                                            }}
                                            styles={{
                                                menu: (baseStyles) => ({
                                                    ...baseStyles,
                                                    zIndex: 2,
                                                }),
                                                menuList: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    textAlign: 'left'
                                                }),
                                                singleValue: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    textAlign: 'left',
                                                    color: state.isDisabled ? 'black' : 'inherit'
                                                }),
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    fontSize: '16px',
                                                    background: state.isDisabled ? '#F9F9F9' : '#fff',
                                                    color: '#323840',
                                                    border: '1px solid var(--input-border-color)',
                                                    borderColor: 'var(--input-border-color)',
                                                    borderRadius: '10px',
                                                    boxSizing: 'border-box',
                                                    height: '50px',
                                                    textAlign: 'left',
                                                    '&:hover': {
                                                        borderColor: 'var(--input-border-color)'
                                                    }
                                                }),
                                                placeholder: (baseStyles) => ({
                                                    ...baseStyles,
                                                    color: 'var(--border-color)'
                                                }),
                                                indicatorSeparator: (baseStyles) => ({
                                                    display: 'none'
                                                }),
                                                dropdownIndicator: (baseStyles) => ({
                                                    ...baseStyles,
                                                    '& svg': {
                                                        fill: '#000'
                                                    }
                                                })
                                            }}
                                            value={props.form3Details.category}
                                            // onBlur={getFormErrors}
                                            // defaultValue={categoryList[0]}
                                            onChange={(value) => {
                                                if (value) {
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        category: value
                                                    }));
                                                    setIsCTADisabled(prevState => ({ ...prevState, productDetailsCTA: false }))
                                                }
                                                else
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        product: null
                                                    }));
                                            }}
                                        /> </div>
                                    : null
                            }
                            {
                                tabNew[activeTab].includes(7) ? <div className="did-floating-label-content w-100">
                                    <label className="did-floating-label">Product<span className='text-danger'>*</span></label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable
                                        name="products"
                                        components={{ DropdownIndicator }}
                                        placeholder="Select product"
                                        options={productList}
                                        classNames={{
                                            control: (state) =>
                                                form3Errors.product ? 'border-error' : '',
                                        }}
                                        styles={{
                                            container: (baseStyles) => ({
                                                ...baseStyles,
                                                width: '100%'
                                            }),
                                            menu: (baseStyles) => ({
                                                ...baseStyles,
                                                zIndex: 2,
                                            }),
                                            menuList: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            singleValue: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                fontSize: '16px',
                                                background: '#fff',
                                                color: '#323840',
                                                border: '1px solid var(--input-border-color)',
                                                borderColor: 'var(--input-border-color)',
                                                borderRadius: '10px',
                                                boxSizing: 'border-box',
                                                height: '50px',
                                                textAlign: 'left',
                                                '&:hover': {
                                                    borderColor: 'var(--input-border-color)'
                                                }
                                            }),
                                            placeholder: (baseStyles) => ({
                                                ...baseStyles,
                                                color: 'var(--border-color)'
                                            }),
                                            indicatorSeparator: (baseStyles) => ({
                                                display: 'none'
                                            }),
                                            dropdownIndicator: (baseStyles) => ({
                                                ...baseStyles,
                                                '& svg': {
                                                    fill: '#000'
                                                }
                                            })
                                        }}
                                        value={props.form3Details.product}
                                        // defaultValue={productList[0]}
                                        // onBlur={getFormErrors}
                                        onChange={(value) => {
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                product: value
                                            }))
                                            // setIsCTADsiabled(prevState => ({ ...prevState, productDetailsCTA: false }))
                                        }}
                                    />
                                </div> : null
                            }
                            <button type='button' className='btn btn-outline' onClick={() => goToNextStep('next', 'product details', 'issue details', '')}>Next section</button>
                        </>
                    case 'purchase details':
                        return <>
                            {
                                tabNew[activeTab].includes(1) ? <div className="did-floating-label-content ">
                                    <label className="did-floating-label">Order ID<span className='text-danger'>*</span></label>
                                    <input className={`did-floating-input ${form3Errors.orderId ? 'border-error' : ''}`} type="text" placeholder="Enter Order ID"
                                        value={props.form3Details.orderId || ''}
                                        // onBlur={getFormErrors}
                                        onChange={(event) => {
                                            event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                orderId: event.target.value
                                            }))
                                        }}
                                    />
                                    {
                                        form3Errors.orderId ? <span className='error-msg'>Please enter order id</span> : null
                                    }
                                </div> : null
                            }
                            {
                                tabNew[activeTab].includes(5) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label">Purchase Channel<span className='text-danger'>*</span></label>
                                    <Select
                                        className="basic-single "
                                        classNamePrefix="select"
                                        isSearchable
                                        name="channel"
                                        options={[{ "label": "Amazon", "value": "Amazon" }, { "label": "Flipkart", "value": "Flipkart" }, { "label": "1 MG", "value": "1 MG" }, { "label": "BeatXP Website", "value": "BeatXP Website" }, { "label": "Jio Mart", "value": "Jio Mart" }, { "label": "Snapdeal", "value": "Snapdeal" }, { "label": "Netmeds", "value": "Netmeds" }, { "label": "Meesho", "value": "Meesho" }, { "label": "Moblix", "value": "Moblix" }, { "label": "Nyka", "value": "Nyka" }, { "label": "Tata Cliq", "value": "Tata Cliq" }, { "label": "Shopclues", "value": "Shopclues" }, { "label": "Pharmeasy", "value": "Pharmeasy" }, { "label": "Myntra", "value": "Myntra" }, { "label": "Cred", "value": "Cred" }, { "label": "Blinkit", "value": "Blinkit" }, { "label": "B2B", "value": "B2B" }, { "label": "Others", "value": "Others" }]}
                                        classNames={{
                                            control: (state) =>
                                                form3Errors.channel ? 'border-error' : '',
                                        }}
                                        components={{ DropdownIndicator }}
                                        placeholder="Select purchase channel"
                                        styles={{
                                            menu: (baseStyles) => ({
                                                ...baseStyles,
                                                zIndex: 2,
                                            }),
                                            menuList: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            singleValue: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                fontSize: '16px',
                                                background: '#fff',
                                                color: '#323840',
                                                border: '1px solid var(--input-border-color)',
                                                borderColor: 'var(--input-border-color)',
                                                borderRadius: '10px',
                                                boxSizing: 'border-box',
                                                height: '50px',
                                                textAlign: 'left',
                                                '&:hover': {
                                                    borderColor: 'var(--input-border-color)'
                                                }
                                            }),
                                            placeholder: (baseStyles) => ({
                                                ...baseStyles,
                                                color: 'var(--border-color)'
                                            }),
                                            indicatorSeparator: (baseStyles) => ({
                                                display: 'none'
                                            }),
                                            container: (baseStyles) => ({
                                                ...baseStyles,
                                                width: '100%'
                                            }),
                                            dropdownIndicator: (baseStyles) => ({
                                                ...baseStyles,
                                                '& svg': {
                                                    fill: '#000'
                                                }
                                            })
                                        }}
                                        value={props.form3Details.channel}
                                        // onBlur={getFormErrors}
                                        // defaultValue={props.form3Details.channel}
                                        onChange={(value) => {
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                channel: value
                                            }))
                                        }}
                                    />
                                    {
                                        form3Errors.channel ? <span className='error-msg'>Please select channel</span> : null
                                    }
                                </div> : null
                            }{
                                tabNew[activeTab].includes(2) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label">Invoice Number<span className='text-danger'>*</span></label>
                                    <input className={`did-floating-input ${form3Errors.invoice ? 'border-error' : ''}`} type="text"
                                        value={props.form3Details.invoice || ''}
                                        // onBlur={getFormErrors}
                                        placeholder="Enter invoice number"
                                        onChange={(event) => {
                                            event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                invoice: event.target.value
                                            }))
                                        }} />
                                    {
                                        form3Errors.invoice ? <span className='error-msg'>Please enter invoice number</span> : null
                                    }
                                </div> : null
                            }

                            {
                                tabNew[activeTab].includes(19) ? <div className="did-floating-label-content position-relative">
                                    <label className="did-floating-label"
                                        style={{
                                            left: '54px'
                                        }}>Enter Invoice Value<span className='text-danger'>*</span></label>
                                    <span id='price' className={`${form3Errors.invoiceVal ? 'border-error' : ''} text-dark`}>₹</span>
                                    <input className={`did-floating-input ${form3Errors.invoiceVal ? 'border-error' : ''}`}
                                        type="number" placeholder="Enter Invoice Number"
                                        value={props.form3Details.invoiceVal || ''}
                                        // onBlur={getFormErrors}
                                        style={{
                                            paddingLeft: '58px'
                                        }}
                                        onChange={(event) => {
                                            event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                invoiceVal: event.target.value
                                            }))
                                        }} />
                                    {
                                        form3Errors.invoiceVal ? <span className='error-msg'>Please enter invoice value</span> : null
                                    }
                                </div> : null
                            }
                            {
                                tabNew[activeTab].includes(20) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label">Invoice Date<span className='text-danger'>*</span></label>
                                    <DatePicker placeholderText="Select invoice date"
                                        dateFormat="dd/MM/yyyy"
                                        selected={props.form3Details.invoiceDate || ''}
                                        maxDate={new Date()}
                                        onChange={(date) => {
                                            // event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                invoiceDate: date
                                            }))
                                        }}
                                        className={`did-floating-input ${form3Errors.invoiceDate ? 'border-error' : ''}`} />
                                    <span id='calendar'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.78049 1.68293C5.78049 1.30576 5.47474 1 5.09756 1C4.72039 1 4.41463 1.30576 4.41463 1.68293V2.02849C4.07594 2.03379 3.77499 2.04591 3.50991 2.0736C3.0186 2.12494 2.5732 2.23576 2.17709 2.5099C1.90684 2.69695 1.67256 2.93123 1.48551 3.20148C1.21137 3.59759 1.10055 4.04299 1.04922 4.5343C1.00413 4.96577 1.00034 5.49229 1.00003 6.12195L1 6.22673C1 6.25061 1 6.27463 1 6.2988V10.2677C0.99998 11.1925 0.99996 11.955 1.0811 12.5586C1.16629 13.1922 1.35203 13.7518 1.8001 14.1999C2.24817 14.648 2.80778 14.8337 3.44142 14.9189C4.04496 15.0001 4.80752 15 5.73227 15H9.9262C10.8509 15 11.6136 15.0001 12.2171 14.9189C12.8508 14.8337 13.4104 14.648 13.8584 14.1999C14.3065 13.7518 14.4922 13.1922 14.5775 12.5586C14.6586 11.955 14.6585 11.1925 14.6585 10.2677V6.2988C14.6585 6.27792 14.6585 6.25709 14.6585 6.23643V6.12195C14.6582 5.49229 14.6544 4.96577 14.6093 4.5343C14.558 4.04299 14.4472 3.59759 14.173 3.20148C13.986 2.93123 13.7517 2.69695 13.4814 2.5099C13.0853 2.23576 12.6399 2.12494 12.1486 2.0736C11.8835 2.04591 11.5826 2.03379 11.2439 2.02849V1.68293C11.2439 1.30576 10.9382 1 10.561 1C10.1838 1 9.87805 1.30576 9.87805 1.68293V2.02439H5.78049V1.68293ZM13.2926 6.12195C13.2921 5.48238 13.2878 5.03001 13.2509 4.67624C13.2111 4.29632 13.1399 4.10881 13.0499 3.97879C12.9564 3.84367 12.8393 3.72652 12.7041 3.633C12.5741 3.54301 12.3866 3.47176 12.0067 3.43206C11.7943 3.40988 11.5464 3.39946 11.2439 3.39456V3.73171C11.2439 4.10887 10.9382 4.41463 10.561 4.41463C10.1838 4.41463 9.87805 4.10887 9.87805 3.73171V3.39024H5.78049V3.73171C5.78049 4.10887 5.47474 4.41463 5.09756 4.41463C4.72039 4.41463 4.41463 4.10887 4.41463 3.73171V3.39456C4.11207 3.39946 3.8642 3.40988 3.65185 3.43206C3.27193 3.47176 3.08442 3.54301 2.9544 3.633C2.81928 3.72652 2.70213 3.84367 2.60861 3.97879C2.51863 4.10881 2.44738 4.29632 2.40768 4.67624C2.37071 5.03001 2.36641 5.48238 2.36592 6.12195H13.2926ZM2.36585 7.4878V10.2195C2.36585 11.2046 2.36731 11.8747 2.43478 12.3766C2.49961 12.8588 2.61391 13.0821 2.76591 13.2341C2.91791 13.3861 3.14124 13.5004 3.62342 13.5652C4.12524 13.6327 4.79538 13.6341 5.78049 13.6341H9.87805C10.8632 13.6341 11.5333 13.6327 12.0351 13.5652C12.5173 13.5004 12.7406 13.3861 12.8926 13.2341C13.0446 13.0821 13.159 12.8588 13.2238 12.3766C13.2912 11.8747 13.2927 11.2046 13.2927 10.2195V7.4878H2.36585Z" fill="#FF8300" />
                                        </svg>
                                    </span>
                                    {
                                        form3Errors.invoiceDate ? <span className='error-msg'>Please select invoice date</span> : null
                                    }
                                </div> : null
                            }
                            {
                                tabNew[activeTab].includes(10) ? <div className="did-floating-label-content position-relative">
                                    <label className="did-floating-label">Order Purchase date<span className='text-danger'>*</span></label>
                                    <DatePicker placeholderText="Select order purchase date"
                                        dateFormat="dd/MM/yyyy"
                                        selected={props.form3Details.orderDate || ''}
                                        maxDate={new Date()}
                                        onChange={(date) => {
                                            // event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                orderDate: date
                                            }))
                                        }}
                                        className={`did-floating-input ${form3Errors.orderDate ? 'border-error' : ''}`} />
                                    <span id='calendar'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.78049 1.68293C5.78049 1.30576 5.47474 1 5.09756 1C4.72039 1 4.41463 1.30576 4.41463 1.68293V2.02849C4.07594 2.03379 3.77499 2.04591 3.50991 2.0736C3.0186 2.12494 2.5732 2.23576 2.17709 2.5099C1.90684 2.69695 1.67256 2.93123 1.48551 3.20148C1.21137 3.59759 1.10055 4.04299 1.04922 4.5343C1.00413 4.96577 1.00034 5.49229 1.00003 6.12195L1 6.22673C1 6.25061 1 6.27463 1 6.2988V10.2677C0.99998 11.1925 0.99996 11.955 1.0811 12.5586C1.16629 13.1922 1.35203 13.7518 1.8001 14.1999C2.24817 14.648 2.80778 14.8337 3.44142 14.9189C4.04496 15.0001 4.80752 15 5.73227 15H9.9262C10.8509 15 11.6136 15.0001 12.2171 14.9189C12.8508 14.8337 13.4104 14.648 13.8584 14.1999C14.3065 13.7518 14.4922 13.1922 14.5775 12.5586C14.6586 11.955 14.6585 11.1925 14.6585 10.2677V6.2988C14.6585 6.27792 14.6585 6.25709 14.6585 6.23643V6.12195C14.6582 5.49229 14.6544 4.96577 14.6093 4.5343C14.558 4.04299 14.4472 3.59759 14.173 3.20148C13.986 2.93123 13.7517 2.69695 13.4814 2.5099C13.0853 2.23576 12.6399 2.12494 12.1486 2.0736C11.8835 2.04591 11.5826 2.03379 11.2439 2.02849V1.68293C11.2439 1.30576 10.9382 1 10.561 1C10.1838 1 9.87805 1.30576 9.87805 1.68293V2.02439H5.78049V1.68293ZM13.2926 6.12195C13.2921 5.48238 13.2878 5.03001 13.2509 4.67624C13.2111 4.29632 13.1399 4.10881 13.0499 3.97879C12.9564 3.84367 12.8393 3.72652 12.7041 3.633C12.5741 3.54301 12.3866 3.47176 12.0067 3.43206C11.7943 3.40988 11.5464 3.39946 11.2439 3.39456V3.73171C11.2439 4.10887 10.9382 4.41463 10.561 4.41463C10.1838 4.41463 9.87805 4.10887 9.87805 3.73171V3.39024H5.78049V3.73171C5.78049 4.10887 5.47474 4.41463 5.09756 4.41463C4.72039 4.41463 4.41463 4.10887 4.41463 3.73171V3.39456C4.11207 3.39946 3.8642 3.40988 3.65185 3.43206C3.27193 3.47176 3.08442 3.54301 2.9544 3.633C2.81928 3.72652 2.70213 3.84367 2.60861 3.97879C2.51863 4.10881 2.44738 4.29632 2.40768 4.67624C2.37071 5.03001 2.36641 5.48238 2.36592 6.12195H13.2926ZM2.36585 7.4878V10.2195C2.36585 11.2046 2.36731 11.8747 2.43478 12.3766C2.49961 12.8588 2.61391 13.0821 2.76591 13.2341C2.91791 13.3861 3.14124 13.5004 3.62342 13.5652C4.12524 13.6327 4.79538 13.6341 5.78049 13.6341H9.87805C10.8632 13.6341 11.5333 13.6327 12.0351 13.5652C12.5173 13.5004 12.7406 13.3861 12.8926 13.2341C13.0446 13.0821 13.159 12.8588 13.2238 12.3766C13.2912 11.8747 13.2927 11.2046 13.2927 10.2195V7.4878H2.36585Z" fill="#FF8300" />
                                        </svg>
                                    </span>
                                    {
                                        form3Errors.orderDate ? <span className='error-msg'>Please select order date</span> : null
                                    }
                                </div> : null
                            }
                            {
                                tabNew[activeTab].includes(11) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label">Delivery Date</label>
                                    <DatePicker placeholderText="Select delivery date"
                                        dateFormat="dd/MM/yyyy"
                                        selected={props.form3Details.deliveryDate || ''}
                                        maxDate={new Date()}
                                        onChange={(date) => {
                                            // event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                deliveryDate: date
                                            }))
                                        }}
                                        className={`did-floating-input ${form3Errors.deliveryDate ? 'border-error' : ''}`} />
                                    <span id='calendar'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.78049 1.68293C5.78049 1.30576 5.47474 1 5.09756 1C4.72039 1 4.41463 1.30576 4.41463 1.68293V2.02849C4.07594 2.03379 3.77499 2.04591 3.50991 2.0736C3.0186 2.12494 2.5732 2.23576 2.17709 2.5099C1.90684 2.69695 1.67256 2.93123 1.48551 3.20148C1.21137 3.59759 1.10055 4.04299 1.04922 4.5343C1.00413 4.96577 1.00034 5.49229 1.00003 6.12195L1 6.22673C1 6.25061 1 6.27463 1 6.2988V10.2677C0.99998 11.1925 0.99996 11.955 1.0811 12.5586C1.16629 13.1922 1.35203 13.7518 1.8001 14.1999C2.24817 14.648 2.80778 14.8337 3.44142 14.9189C4.04496 15.0001 4.80752 15 5.73227 15H9.9262C10.8509 15 11.6136 15.0001 12.2171 14.9189C12.8508 14.8337 13.4104 14.648 13.8584 14.1999C14.3065 13.7518 14.4922 13.1922 14.5775 12.5586C14.6586 11.955 14.6585 11.1925 14.6585 10.2677V6.2988C14.6585 6.27792 14.6585 6.25709 14.6585 6.23643V6.12195C14.6582 5.49229 14.6544 4.96577 14.6093 4.5343C14.558 4.04299 14.4472 3.59759 14.173 3.20148C13.986 2.93123 13.7517 2.69695 13.4814 2.5099C13.0853 2.23576 12.6399 2.12494 12.1486 2.0736C11.8835 2.04591 11.5826 2.03379 11.2439 2.02849V1.68293C11.2439 1.30576 10.9382 1 10.561 1C10.1838 1 9.87805 1.30576 9.87805 1.68293V2.02439H5.78049V1.68293ZM13.2926 6.12195C13.2921 5.48238 13.2878 5.03001 13.2509 4.67624C13.2111 4.29632 13.1399 4.10881 13.0499 3.97879C12.9564 3.84367 12.8393 3.72652 12.7041 3.633C12.5741 3.54301 12.3866 3.47176 12.0067 3.43206C11.7943 3.40988 11.5464 3.39946 11.2439 3.39456V3.73171C11.2439 4.10887 10.9382 4.41463 10.561 4.41463C10.1838 4.41463 9.87805 4.10887 9.87805 3.73171V3.39024H5.78049V3.73171C5.78049 4.10887 5.47474 4.41463 5.09756 4.41463C4.72039 4.41463 4.41463 4.10887 4.41463 3.73171V3.39456C4.11207 3.39946 3.8642 3.40988 3.65185 3.43206C3.27193 3.47176 3.08442 3.54301 2.9544 3.633C2.81928 3.72652 2.70213 3.84367 2.60861 3.97879C2.51863 4.10881 2.44738 4.29632 2.40768 4.67624C2.37071 5.03001 2.36641 5.48238 2.36592 6.12195H13.2926ZM2.36585 7.4878V10.2195C2.36585 11.2046 2.36731 11.8747 2.43478 12.3766C2.49961 12.8588 2.61391 13.0821 2.76591 13.2341C2.91791 13.3861 3.14124 13.5004 3.62342 13.5652C4.12524 13.6327 4.79538 13.6341 5.78049 13.6341H9.87805C10.8632 13.6341 11.5333 13.6327 12.0351 13.5652C12.5173 13.5004 12.7406 13.3861 12.8926 13.2341C13.0446 13.0821 13.159 12.8588 13.2238 12.3766C13.2912 11.8747 13.2927 11.2046 13.2927 10.2195V7.4878H2.36585Z" fill="#FF8300" />
                                        </svg>
                                    </span>
                                </div> : null
                            }
                            {
                                tabNew[activeTab].includes(18) ? <div className='position-relative upload-wrapper'>
                                    <label className='file-label' htmlFor="invoice-upload">Upload Invoice<span className='text-danger'>*</span></label>
                                    <div className={`form-input-group position-relative ${form3Errors.invoiceDetails ? 'border-error' : ''}`}>
                                        <span className='centered'>Click to upload</span>
                                        <input
                                            type="file"
                                            name='invoice-upload'
                                            id='invoice-upload'
                                            onChange={(event) => {
                                                event.persist();
                                                fileUploadHandler(event, 'invoice');
                                                setIsCTADisabled(prevState => ({ ...prevState, purchaseDetailsCTA: false }))
                                            }}
                                            accept='image/*, application/*' />
                                        <svg className='centered' xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                            <path d="M15 8.31843C15 8.10318 14.9122 7.89675 14.7559 7.74455C14.5996 7.59234 14.3877 7.50684 14.1667 7.50684C13.9457 7.50684 13.7337 7.59234 13.5774 7.74455C13.4211 7.89675 13.3333 8.10318 13.3333 8.31843V11.0237C13.3333 11.3825 13.187 11.7265 12.9265 11.9802C12.6661 12.2339 12.3128 12.3764 11.9444 12.3764H3.05556C2.6872 12.3764 2.33393 12.2339 2.07346 11.9802C1.813 11.7265 1.66667 11.3825 1.66667 11.0237V8.31843C1.66667 8.10318 1.57887 7.89675 1.42259 7.74455C1.26631 7.59234 1.05435 7.50684 0.833333 7.50684C0.61232 7.50684 0.400358 7.59234 0.244078 7.74455C0.0877973 7.89675 0 8.10318 0 8.31843V11.0237C0 11.813 0.321924 12.5699 0.894951 13.128C1.46798 13.6861 2.24517 13.9996 3.05556 13.9996H11.9444C12.7548 13.9996 13.532 13.6861 14.105 13.128C14.6781 12.5699 15 11.813 15 11.0237V8.31843Z" fill="#FF8300" />
                                            <path d="M7.49871 10.8727C7.71973 10.8727 7.93169 10.7871 8.08797 10.6349C8.24425 10.4827 8.33205 10.2763 8.33205 10.0611V2.63768L10.4848 4.5314C10.6512 4.65668 10.8601 4.71604 11.0696 4.69757C11.2791 4.67911 11.4736 4.58418 11.6142 4.43184C11.7548 4.27949 11.8311 4.081 11.8277 3.87619C11.8243 3.67137 11.7415 3.47538 11.5959 3.32754L8.05427 0.205604L8.00427 0.170435L7.94316 0.12715L7.86816 0.08657L7.80427 0.0568119L7.71538 0.0297586L7.65149 0.0135269C7.60384 0.00493611 7.55551 0.000409786 7.50705 0H7.49871C7.45025 0.000409786 7.40192 0.00493611 7.35427 0.0135269L7.29038 0.0297586L7.20149 0.0568119L7.1376 0.08657L7.0626 0.12715L7.00149 0.170435L6.94316 0.205604L3.39594 3.33024C3.25036 3.47809 3.16756 3.67408 3.16417 3.87889C3.16078 4.08371 3.23703 4.2822 3.37764 4.43454C3.51824 4.58688 3.7128 4.68181 3.92227 4.70028C4.13174 4.71874 4.34064 4.65938 4.50705 4.53411L6.65983 2.64039V10.0611C6.65982 10.1681 6.68156 10.2741 6.72379 10.3729C6.76601 10.4717 6.82789 10.5614 6.90586 10.6369C6.98384 10.7123 7.07636 10.772 7.1781 10.8124C7.27985 10.8529 7.38881 10.8734 7.49871 10.8727Z" fill="#FF8300" />
                                        </svg>
                                    </div>
                                    {
                                        form3Errors.invoiceDetails ? <span className='error-msg'>Please upload file here</span> : null
                                    }
                                    <span className='text-brand d-flex cursor-text'>Image size should be less than 5MB</span>
                                    {
                                        props.form3Details.invoiceDetails ?
                                            <div className='file-box-wrapper'>
                                                {getHTML()}
                                            </div> : null
                                    }
                                </div> : null
                            }
                            <div className='d-grid' id="info-wrapper">
                                <div className='bg-grey'>
                                    <span>How can I get my invoice from Amazon?</span>
                                    <div className='item'>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-1.png" alt="image-1" />
                                            <span>Login into Amazon</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-2.png" alt="image-2" />
                                            <span>Go to ‘Returns & Orders</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-3.png" alt="image-3" />
                                            <span>Click Invoice Dropdown</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-4.png" alt="image-4" />
                                            <span>Download Invoice 1</span>
                                        </div>
                                    </div>
                                </div>

                                <div className='bg-grey'>
                                    <span>How can I get my invoice from Flipkart?</span>
                                    <div className='item'>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-5.png" alt="image-5" />
                                            <span>Login into Filpkart</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-6.png" alt="image-6" />
                                            <span>Go to ‘Orders’ in profile</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-7.png" alt="image-7" />
                                            <span>Select product from order list</span>
                                        </div>
                                        <div className='info'>
                                            <img src="https://img.beatxp.com/prod/complaint/info-img-8.png" alt="image-8" />
                                            <span>Click ‘Download Invoice’</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type='button' className='btn btn-outline mr-0 ml-auto' onClick={() => goToNextStep('prev', '', '', 'product details')}>Previous Section</button>
                            <button type='button' className='btn btn-outline ml-0 mr-auto' disabled={isCTADisabled?.purchaseDetailsCTA} onClick={() => goToNextStep('next', 'purchase details', 'issue details', '')}>Next Section</button>
                        </>
                    case 'issue details':
                        return <>
                            {
                                tabNew[activeTab].includes(8) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label"> Problem</label>
                                    <Select
                                        className="basic-single "
                                        classNamePrefix="select"
                                        isSearchable
                                        name="main-problem"
                                        components={{ DropdownIndicator }}
                                        placeholder="Select  problem"
                                        options={mainProblemList}
                                        classNames={{
                                            control: (state) =>
                                                form3Errors.mainProblem ? 'border-error' : '',
                                        }}
                                        styles={{
                                            container: (baseStyles) => ({
                                                ...baseStyles,
                                                width: '100%'
                                            }),
                                            menu: (baseStyles) => ({
                                                ...baseStyles,
                                                zIndex: 2,
                                            }),
                                            menuList: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            singleValue: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                fontSize: '16px',
                                                background: '#fff',
                                                border: '1px solid  var(--input-border-color)',
                                                borderColor: ' var(--input-border-color)',
                                                borderRadius: '10px',
                                                boxSizing: 'border-box',
                                                height: '50px',
                                                textAlign: 'left',
                                                minWidth: '290px',
                                                '&:hover': {
                                                    borderColor: ' var(--input-border-color)'
                                                }
                                            }),
                                            placeholder: (baseStyles) => ({
                                                ...baseStyles,
                                                color: 'var(--border-color)'
                                            }),
                                            indicatorSeparator: (baseStyles) => ({
                                                display: 'none'
                                            }),
                                            dropdownIndicator: (baseStyles) => ({
                                                ...baseStyles,
                                                '& svg': {
                                                    fill: '#000'
                                                }
                                            })
                                        }}
                                        value={props.form3Details.mainProblem}
                                        // onBlur={getFormErrors}
                                        // defaultValue={mainProblemList[0]}
                                        onChange={(value) => {
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                mainProblem: value
                                            }));
                                            if (props.form1Details.type?.value !== 'delivery') getSubProblemList(props.form3Details.category.value, value.value.toString());
                                        }}
                                    />
                                </div> : null
                            }

                            {
                                tabNew[activeTab].includes(9) ? <div className="did-floating-label-content">
                                    <label className="did-floating-label">Sub Problem</label>
                                    <Select
                                        className="basic-single "
                                        classNamePrefix="select"
                                        isSearchable
                                        name="sub-problem"
                                        components={{ DropdownIndicator }}
                                        placeholder="Sub Problem"
                                        options={subProblemList}
                                        classNames={{
                                            control: (state) =>
                                                form3Errors.subProblem ? 'border-error' : '',
                                        }}
                                        styles={{
                                            container: (baseStyles) => ({
                                                ...baseStyles,
                                                width: '100%'
                                            }),
                                            menu: (baseStyles) => ({
                                                ...baseStyles,
                                                zIndex: 2,
                                            }),
                                            menuList: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            indicatorSeparator: (baseStyles) => ({
                                                display: 'none'
                                            }),
                                            singleValue: (baseStyles, state) => ({
                                                ...baseStyles,
                                                textAlign: 'left'
                                            }),
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                fontSize: '16px',
                                                background: '#fff',
                                                border: '1px solid var(--input-border-color)',
                                                borderColor: ' var(--input-border-color)',
                                                borderRadius: '10px',
                                                boxSizing: 'border-box',
                                                height: '50px',
                                                minWidth: '290px',
                                                textAlign: 'left',
                                                '&:hover': {
                                                    borderColor: ' var(--input-border-color)'
                                                }
                                            }),
                                            placeholder: (baseStyles) => ({
                                                ...baseStyles,
                                                color: 'var(--border-color)'
                                            }),
                                            dropdownIndicator: (baseStyles) => ({
                                                ...baseStyles,
                                                '& svg': {
                                                    fill: '#000'
                                                }
                                            })
                                        }}
                                        value={props.form3Details.subProblem}
                                        // onBlur={getFormErrors}
                                        // defaultValue={subProblemList[0]}
                                        onChange={(value) => {
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                subProblem: value
                                            }));
                                        }}
                                    />
                                </div> : null
                            }

                            {
                                commsList && commsList.subProblemInstruction ?
                                    < p id='commsWrapper' dangerouslySetInnerHTML={{ __html: commsList.subProblemInstruction }}></p>
                                    : null
                            }


                            {
                                tabNew[activeTab].includes(3) ? <div className='bg-grey'>
                                    <div className='file-upload-wrapper w-100'>
                                        <div className="form-input-group position-relative">
                                            <label className='file-label' htmlFor="images-upload">Upload Images{props.form1Details.type?.value !== 'air_bike_installation' ? <span className='text-danger'>*</span> : null}</label>
                                            <div className={`position-relative ${form3Errors.images ? 'border-error' : ''}`}>
                                                <span>Click to upload</span>
                                                <input
                                                    type="file"
                                                    name='images-upload'
                                                    id='images-upload'
                                                    onChange={(event) => {
                                                        event.persist();
                                                        fileUploadHandler(event, 'images');
                                                    }}
                                                    multiple
                                                    accept='image/*' />

                                                <span id='calendar'>
                                                    <svg className='centered' xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                        <path d="M15 8.31843C15 8.10318 14.9122 7.89675 14.7559 7.74455C14.5996 7.59234 14.3877 7.50684 14.1667 7.50684C13.9457 7.50684 13.7337 7.59234 13.5774 7.74455C13.4211 7.89675 13.3333 8.10318 13.3333 8.31843V11.0237C13.3333 11.3825 13.187 11.7265 12.9265 11.9802C12.6661 12.2339 12.3128 12.3764 11.9444 12.3764H3.05556C2.6872 12.3764 2.33393 12.2339 2.07346 11.9802C1.813 11.7265 1.66667 11.3825 1.66667 11.0237V8.31843C1.66667 8.10318 1.57887 7.89675 1.42259 7.74455C1.26631 7.59234 1.05435 7.50684 0.833333 7.50684C0.61232 7.50684 0.400358 7.59234 0.244078 7.74455C0.0877973 7.89675 0 8.10318 0 8.31843V11.0237C0 11.813 0.321924 12.5699 0.894951 13.128C1.46798 13.6861 2.24517 13.9996 3.05556 13.9996H11.9444C12.7548 13.9996 13.532 13.6861 14.105 13.128C14.6781 12.5699 15 11.813 15 11.0237V8.31843Z" fill="#FF8300" />
                                                        <path d="M7.49871 10.8727C7.71973 10.8727 7.93169 10.7871 8.08797 10.6349C8.24425 10.4827 8.33205 10.2763 8.33205 10.0611V2.63768L10.4848 4.5314C10.6512 4.65668 10.8601 4.71604 11.0696 4.69757C11.2791 4.67911 11.4736 4.58418 11.6142 4.43184C11.7548 4.27949 11.8311 4.081 11.8277 3.87619C11.8243 3.67137 11.7415 3.47538 11.5959 3.32754L8.05427 0.205604L8.00427 0.170435L7.94316 0.12715L7.86816 0.08657L7.80427 0.0568119L7.71538 0.0297586L7.65149 0.0135269C7.60384 0.00493611 7.55551 0.000409786 7.50705 0H7.49871C7.45025 0.000409786 7.40192 0.00493611 7.35427 0.0135269L7.29038 0.0297586L7.20149 0.0568119L7.1376 0.08657L7.0626 0.12715L7.00149 0.170435L6.94316 0.205604L3.39594 3.33024C3.25036 3.47809 3.16756 3.67408 3.16417 3.87889C3.16078 4.08371 3.23703 4.2822 3.37764 4.43454C3.51824 4.58688 3.7128 4.68181 3.92227 4.70028C4.13174 4.71874 4.34064 4.65938 4.50705 4.53411L6.65983 2.64039V10.0611C6.65982 10.1681 6.68156 10.2741 6.72379 10.3729C6.76601 10.4717 6.82789 10.5614 6.90586 10.6369C6.98384 10.7123 7.07636 10.772 7.1781 10.8124C7.27985 10.8529 7.38881 10.8734 7.49871 10.8727Z" fill="#FF8300" />
                                                    </svg>
                                                </span>
                                            </div>
                                            <span className='text-brand d-flex cursor-text'>Image size should be less than 5MB</span>
                                        </div>
                                    </div>
                                    <div className='w-70 d-none'>
                                        <span>Sample Images</span>
                                        <div className='d-flex justify-content-around'>
                                            <div className='d-inline-flex flex-column'>
                                                <img src='https://img.beatxp.com/prod/complaint/info-img-9.png' alt='img-9' />

                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="10" fill="#00A600" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M13.8175 8.13501L9.32747 12.805C9.07747 13.065 8.6775 13.065 8.4275 12.805L6.1875 10.455C5.9375 10.195 5.9375 9.77504 6.1875 9.51499C6.4375 9.25501 6.83747 9.25501 7.08747 9.51499L8.88747 11.395L12.9275 7.19499C13.1775 6.935 13.5774 6.935 13.8274 7.19499C14.0675 7.45497 14.0675 7.87502 13.8175 8.13501Z" fill="white" />
                                                </svg>

                                                <span>Correct Image</span>
                                            </div>
                                            <div className='d-inline-flex flex-column'>
                                                <img src='https://img.beatxp.com/prod/complaint/info-img-10.png' alt='img-10' />

                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10" r="10" fill="#FF0000" />
                                                    <path d="M12.843 7.15724C12.6336 6.94784 12.2942 6.94784 12.0848 7.15724L10 9.24187L7.91518 7.15705C7.70578 6.94765 7.36644 6.94765 7.15705 7.15705C6.94765 7.36644 6.94765 7.70578 7.15705 7.91518L9.24187 10L7.15705 12.0848C6.94765 12.2942 6.94765 12.6336 7.15705 12.843C7.36644 13.0523 7.70578 13.0523 7.91518 12.843L10 10.7581L12.0848 12.843C12.2942 13.0523 12.6336 13.0523 12.843 12.843C13.0523 12.6336 13.0523 12.2942 12.843 12.0848L10.7581 10L12.843 7.91518C13.0523 7.70578 13.0523 7.36644 12.843 7.15705V7.15724Z" fill="white" />
                                                </svg>

                                                <span>Incorrect Image</span>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        props.form3Details.images && props.form3Details.images.length ?
                                            <div className='file-box-wrapper'>
                                                {
                                                    [...props.form3Details.images].map(item => (
                                                        <span className='file-box-image' key={item.name}
                                                            style={{
                                                                backgroundImage: `url(${URL.createObjectURL(item)})`
                                                            }}>
                                                            <button type='button'>
                                                                <span onClick={() => { setImgSrc({ type: 'img', src: item }); setShowImage(true) }}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M7.50026 5C6.39754 5 5.49991 5.89759 5.49991 6.99965C5.49991 8.10242 6.39754 9 7.50026 9C8.60299 9 9.50061 8.10242 9.50061 6.99965C9.50061 5.89759 8.60299 5 7.50026 5ZM7.49947 10C5.84276 10 4.5 8.65721 4.5 6.99974C4.5 5.3428 5.84276 4 7.49947 4C9.15619 4 10.4989 5.3428 10.4989 6.99974C10.4989 8.65721 9.15619 10 7.49947 10ZM7.5 12C10.4788 12 13.3987 9.31873 13.976 6.9998C13.3987 4.68119 10.4787 2 7.5 2C4.52103 2 1.60131 4.68101 1.02397 6.9998C1.60127 9.31891 4.52095 12 7.5 12ZM0 6.99977C0.416593 4.85706 3.35733 1 7.5 1C11.6422 1 14.5834 4.85706 15 6.99977C14.5834 9.14294 11.6422 13 7.5 13C3.35733 13 0.416593 9.14294 0 6.99977Z" fill="white" />
                                                                    </svg>
                                                                </span>
                                                                <span onClick={() => removeItem(item.name, 'images')}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                                                        <path d="M13.0256 2.15385H10.5329L10.2895 1.4761C10.0871 0.605231 9.38851 0 8.57723 0H5.98687C5.17631 0 4.47703 0.605231 4.27456 1.4761L4.03118 2.15385H1.53846C1.24123 2.15385 1 2.39508 1 2.69231C1 2.98954 1.24123 3.23077 1.53846 3.23077H2.4359V12.0256C2.4359 13.1148 3.32113 14 4.41026 14H10.1538C11.243 14 12.1282 13.1148 12.1282 12.0256V3.23077H13.0256C13.3229 3.23077 13.5641 2.98954 13.5641 2.69231C13.5641 2.39508 13.3229 2.15385 13.0256 2.15385ZM5.29979 1.8078L5.31918 1.73887C5.40246 1.34903 5.67744 1.07692 5.98687 1.07692H8.57723C8.88667 1.07692 9.16092 1.34903 9.24492 1.73887L9.38851 2.15385H5.17559L5.29979 1.8078ZM11.0513 12.0256C11.0513 12.5203 10.6485 12.9231 10.1538 12.9231H4.41026C3.91559 12.9231 3.51282 12.5203 3.51282 12.0256V3.23077H11.0513V12.0256ZM5.30769 9.87179V6.28205C5.30769 5.98482 5.54892 5.74359 5.84615 5.74359C6.14338 5.74359 6.38461 5.98482 6.38461 6.28205V9.87179C6.38461 10.169 6.14338 10.4103 5.84615 10.4103C5.54892 10.4103 5.30769 10.169 5.30769 9.87179ZM8.17949 9.87179V6.28205C8.17949 5.98482 8.42072 5.74359 8.71795 5.74359C9.01518 5.74359 9.25641 5.98482 9.25641 6.28205V9.87179C9.25641 10.169 9.01518 10.4103 8.71795 10.4103C8.42072 10.4103 8.17949 10.169 8.17949 9.87179Z" fill="white" />
                                                                    </svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                    ))
                                                }
                                            </div> : null
                                    }
                                    <span className="note">Note: Please consider sample images before uploading your image.</span>
                                </div> : null
                            }

                            {
                                tabNew[activeTab].includes(14) ? <div className='bg-grey'>
                                    <div className='file-upload-wrapper w-100'>
                                        <div className="form-input-group position-relative">
                                            <label className='file-label' htmlFor="video-upload">Upload Videos{props.form1Details.type?.value !== 'air_bike_installation' ? <span className='text-danger'>*</span> : null}</label>
                                            <div className={`position-relative ${form3Errors.video ? 'border-error' : ''}`}>
                                                <span>Click to upload</span>
                                                <input type="file" name='video-upload' id='video-upload'
                                                    onInput={(event) => {
                                                        event.persist();
                                                        fileUploadHandler(event, 'video');
                                                    }}
                                                    accept='video/*' />

                                                <span id='calendar'>
                                                    <svg className='centered' xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                                        <path d="M15 8.31843C15 8.10318 14.9122 7.89675 14.7559 7.74455C14.5996 7.59234 14.3877 7.50684 14.1667 7.50684C13.9457 7.50684 13.7337 7.59234 13.5774 7.74455C13.4211 7.89675 13.3333 8.10318 13.3333 8.31843V11.0237C13.3333 11.3825 13.187 11.7265 12.9265 11.9802C12.6661 12.2339 12.3128 12.3764 11.9444 12.3764H3.05556C2.6872 12.3764 2.33393 12.2339 2.07346 11.9802C1.813 11.7265 1.66667 11.3825 1.66667 11.0237V8.31843C1.66667 8.10318 1.57887 7.89675 1.42259 7.74455C1.26631 7.59234 1.05435 7.50684 0.833333 7.50684C0.61232 7.50684 0.400358 7.59234 0.244078 7.74455C0.0877973 7.89675 0 8.10318 0 8.31843V11.0237C0 11.813 0.321924 12.5699 0.894951 13.128C1.46798 13.6861 2.24517 13.9996 3.05556 13.9996H11.9444C12.7548 13.9996 13.532 13.6861 14.105 13.128C14.6781 12.5699 15 11.813 15 11.0237V8.31843Z" fill="#FF8300" />
                                                        <path d="M7.49871 10.8727C7.71973 10.8727 7.93169 10.7871 8.08797 10.6349C8.24425 10.4827 8.33205 10.2763 8.33205 10.0611V2.63768L10.4848 4.5314C10.6512 4.65668 10.8601 4.71604 11.0696 4.69757C11.2791 4.67911 11.4736 4.58418 11.6142 4.43184C11.7548 4.27949 11.8311 4.081 11.8277 3.87619C11.8243 3.67137 11.7415 3.47538 11.5959 3.32754L8.05427 0.205604L8.00427 0.170435L7.94316 0.12715L7.86816 0.08657L7.80427 0.0568119L7.71538 0.0297586L7.65149 0.0135269C7.60384 0.00493611 7.55551 0.000409786 7.50705 0H7.49871C7.45025 0.000409786 7.40192 0.00493611 7.35427 0.0135269L7.29038 0.0297586L7.20149 0.0568119L7.1376 0.08657L7.0626 0.12715L7.00149 0.170435L6.94316 0.205604L3.39594 3.33024C3.25036 3.47809 3.16756 3.67408 3.16417 3.87889C3.16078 4.08371 3.23703 4.2822 3.37764 4.43454C3.51824 4.58688 3.7128 4.68181 3.92227 4.70028C4.13174 4.71874 4.34064 4.65938 4.50705 4.53411L6.65983 2.64039V10.0611C6.65982 10.1681 6.68156 10.2741 6.72379 10.3729C6.76601 10.4717 6.82789 10.5614 6.90586 10.6369C6.98384 10.7123 7.07636 10.772 7.1781 10.8124C7.27985 10.8529 7.38881 10.8734 7.49871 10.8727Z" fill="#FF8300" />
                                                    </svg>
                                                </span>
                                            </div>
                                            <span className='text-brand d-flex cursor-text'>Video size should be less than 50MB</span>
                                        </div>
                                    </div>
                                    <div className='w-70 d-none'>
                                        <span>Sample Video</span>
                                        <div className='d-flex justify-content-around'>
                                            <div className='d-inline-flex flex-column'>
                                                {
                                                    props.form3Details.subProblem?.value === "Dead on Arrival ( Didn't Switch On)" ?
                                                        <div className='w-70'>
                                                            <span>Sample Video</span>
                                                            <div className='d-flex justify-content-center'>
                                                                <div className='d-inline-flex flex-column sample-video-section' onClick={() => setPlayVideo(true)}>
                                                                    <img src='https://img.beatxp.com/prod/saras/vid_1_thumb.png' />
                                                                    <div className='thumbnail-overlay'></div>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M21 0C32.59 0 42 9.41 42 21C42 32.59 32.59 42 21 42C9.41 42 0 32.59 0 21C0 9.41 9.41 0 21 0ZM29.555 21.832L17.555 29.832C17.248 30.037 16.853 30.056 16.528 29.882C16.203 29.708 16 29.369 16 29V13C16 12.631 16.203 12.292 16.528 12.118C16.853 11.944 17.248 11.963 17.555 12.168L29.555 20.168C29.833 20.353 30 20.666 30 21C30 21.334 29.833 21.647 29.555 21.832Z" fill="white" />
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div> : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        props.form3Details.video ?
                                            <div className='file-box-wrapper'>
                                                {
                                                    <span className='file-box w-100' key={props.form3Details.video.name}>
                                                        <span className='cursor-pointer' onClick={() => { setImgSrc({ src: props.form3Details.video, type: 'video' }); setShowImage(true) }}>
                                                            <svg className='mr-2' xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M1.23127 12.7945C2.87294 14.4018 5.5428 14.4018 7.18447 12.7945L15.1221 5.02289C16.2926 3.87684 16.2926 2.00559 15.1221 0.859541C13.9516 -0.286514 12.0403 -0.286514 10.8698 0.859541L2.93217 8.63114C2.2328 9.31588 2.2328 10.4444 2.93217 11.1291C3.63156 11.8139 4.78418 11.8139 5.48355 11.1291L12.2872 4.46778C12.4427 4.31976 12.5048 4.10123 12.4496 3.89588C12.3945 3.69052 12.2307 3.53014 12.0209 3.47614C11.8112 3.42213 11.588 3.48287 11.4368 3.6351L4.6331 10.2965C4.39016 10.5343 4.02558 10.5344 3.78264 10.2965C3.53971 10.0586 3.53971 9.70167 3.78264 9.4638L11.7203 1.6922C12.4344 0.993058 13.5576 0.993058 14.2717 1.69222C14.9857 2.39137 14.9857 3.49107 14.2716 4.19021L6.33402 11.9618C5.14877 13.1223 3.26695 13.1223 2.08172 11.9618C0.896489 10.8014 0.896489 8.95891 2.08172 7.79847L8.8854 1.1371C9.04109 0.989109 9.10328 0.770486 9.04816 0.565004C8.99303 0.359522 8.82913 0.199046 8.61926 0.145073C8.40939 0.0910999 8.18609 0.151999 8.03494 0.304433L1.23125 6.96579C-0.41042 8.57314 -0.41042 11.1871 1.23127 12.7945Z" fill="#6C6A6A" />
                                                            </svg>
                                                            {props.form3Details.video.name}
                                                        </span>
                                                        <button type='button' onClick={() => removeItem(props.form3Details.video.name, 'video')}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                <path d="M11.6859 0.314477C11.2671 -0.104315 10.5884 -0.104315 10.1696 0.314477L6 4.48373L1.83036 0.314094C1.41157 -0.104698 0.732886 -0.104698 0.314094 0.314094C-0.104698 0.732886 -0.104698 1.41157 0.314094 1.83036L4.48374 6L0.314094 10.1696C-0.104698 10.5884 -0.104698 11.2671 0.314094 11.6859C0.732886 12.1047 1.41157 12.1047 1.83036 11.6859L6 7.51627L10.1696 11.6859C10.5884 12.1047 11.2671 12.1047 11.6859 11.6859C12.1047 11.2671 12.1047 10.5884 11.6859 10.1696L7.51627 6L11.6859 1.83036C12.1047 1.41157 12.1047 0.732886 11.6859 0.314094V0.314477Z" fill="#FF8300" />
                                                            </svg>
                                                        </button>
                                                    </span>
                                                }
                                            </div> : null
                                    }
                                    <span className="note">Note: Please consider sample video and follow all steps before uploading your video.</span>
                                </div> : null
                            }

                            {
                                tabNew[activeTab].includes(4) ? <div className="did-floating-label-content w-100 flex-basis-unset">
                                    <label className="did-floating-label">Remarks</label>
                                    <textarea className="did-floating-input" placeholder="Describe your problem in detail"
                                        value={props.form3Details.comments || ''}
                                        style={{
                                            height: '80px'
                                        }}
                                        onChange={(event) => {
                                            event.persist();
                                            props.setForm3DetailsHandler((prevState) => ({
                                                ...prevState,
                                                comments: event.target.value
                                            }))
                                        }} />
                                </div> : null
                            }
                            <button type='button' className='btn btn-outline mr-0 ml-auto' onClick={() => goToNextStep('prev', '', '', 'product details')}>Previous Section</button>
                            <button type='button' className='btn btn-outline ml-0 mr-auto' onClick={() => goToNextStep('next', 'issue details', 'delivery address')}>Next Section</button>
                        </>
                    case 'delivery address':
                        return <>
                            {
                                tabNew[activeTab].includes(17) ? <div className='w-100'>
                                    <div className='address-wrapper'>
                                        <div className="did-floating-label-content w-100">
                                            <label className="did-floating-label">Address</label>
                                            <input className={`did-floating-input ${form3Errors.deliveryAddress ? 'border-error' : ''}`} type="text" placeholder="Enter your complete address"
                                                value={props.form3Details.deliveryAddress.address || ''}
                                                // onBlur={getFormErrors}
                                                name="address"
                                                maxLength={180}
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        deliveryAddress: { ...props.form3Details.deliveryAddress, address: event.target.value }
                                                    }));
                                                }} />
                                            {
                                                form3Errors.deliveryAddress ? <span className='error-msg'>Please enter address</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id='pincode'>
                                            <label className="did-floating-label">Pincode</label>
                                            <input className={`did-floating-input ${form3Errors.deliveryAddressPincode ? 'border-error' : ''}`} type="number" placeholder="Enter your pincode"
                                                value={props.form3Details.deliveryAddress.pincode || ''}
                                                // onBlur={getFormErrors}
                                                name="pincode"
                                                onChange={(event) => {
                                                    event.persist();
                                                    const val = event.target.value.toString().length > 6 ? event.target.value.slice(0, 6) : event.target.value;
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        deliveryAddress: { ...props.form3Details.deliveryAddress, pincode: val }
                                                    }));
                                                    getLocationDets(val, 'delivery');
                                                }
                                                } />
                                            {
                                                form3Errors.deliveryAddressPincode ? <span className='error-msg'>Please enter pincode</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id='city'>
                                            <label className="did-floating-label">City</label>
                                            <input className={`did-floating-input ${form3Errors.deliveryAddressCity ? 'border-error' : ''}`} type="text" placeholder="Enter your city"
                                                value={props.form3Details.deliveryAddress.city || ''}
                                                // onBlur={getFormErrors}
                                                name="city"
                                                maxLength={20}
                                                disabled={isFieldDisabled['delivery-city'] && props.form3Details.deliveryAddress.pincode}
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        deliveryAddress: { ...props.form3Details.deliveryAddress, city: event.target.value }
                                                    }));
                                                }} />
                                            {
                                                form3Errors.deliveryAddressCity ? <span className='error-msg'>Please enter city</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id="state">
                                            <label className="did-floating-label">State</label>
                                            <input className={`did-floating-input ${form3Errors.deliveryAddressState ? 'border-error' : ''}`} type="text" placeholder="Enter your state"
                                                value={props.form3Details.deliveryAddress.state || ''}
                                                // onBlur={getFormErrors}
                                                name="state"
                                                maxLength={20}
                                                disabled={isFieldDisabled['delivery-state'] && props.form3Details.deliveryAddress.pincode}
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        deliveryAddress: { ...props.form3Details.deliveryAddress, state: event.target.value }
                                                    }));
                                                }} />
                                            {
                                                form3Errors.deliveryAddressState ? <span className='error-msg'>Please enter state</span> : null
                                            }
                                        </div>
                                        <div className="did-floating-label-content" id='landmark'>
                                            <label className="did-floating-label">Landmark</label>
                                            <input className={`did-floating-input ${form3Errors.deliveryAddressLandmark ? 'border-error' : ''}`} type="text" placeholder="Enter landmark"
                                                value={props.form3Details.deliveryAddress.landmark || ''}
                                                // onBlur={getFormErrors}
                                                name="landmark"
                                                onChange={(event) => {
                                                    event.persist();
                                                    props.setForm3DetailsHandler((prevState) => ({
                                                        ...prevState,
                                                        deliveryAddress: { ...props.form3Details.deliveryAddress, landmark: event.target.value }
                                                    }));
                                                }
                                                } />
                                            {
                                                form3Errors.deliveryAddressLandmark ? <span className='error-msg'>Please enter landmark</span> : null
                                            }
                                        </div>
                                    </div>
                                    <button type='button' className='btn btn-outline mr-0 ml-auto' onClick={() => goToNextStep('prev', '', '', 'issue details')}>Previous Section</button>
                                </div> : null
                            }
                            <button type='button' className='btn btn-brand text-white'
                                onClick={submitform}>Submit your complaint
                            </button>
                        </>
                }
                break;
            default:
                break;
        }
    }

    return (
        <div>
            <form id="form3">
                {!['wrong_items', 'poor_quality', 'items_missing'].includes(props.form1Details.type?.value) ? <div className="did-floating-label-content"
                    style={{
                        width: '42vw'
                    }}>
                    <label className="did-floating-label">Complaint/Request Type<span className='text-danger'>*</span></label>
                    <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isSearchable
                        name="type"
                        components={{ DropdownIndicator }}
                        placeholder="Select your complaint/request type"
                        options={complaintTypeOptions2}
                        styles={{
                            menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 2,
                            }),
                            menuList: (baseStyles) => ({
                                ...baseStyles,
                                textAlign: 'left',
                            }),
                            singleValue: (baseStyles) => ({
                                ...baseStyles,
                                textAlign: 'left'
                            }),
                            control: (baseStyles) => ({
                                ...baseStyles,
                                fontSize: '16px',
                                background: '#fff',
                                color: '#323840',
                                border: '1px solid var(--input-border-color)',
                                borderColor: 'var(--input-border-color)',
                                borderRadius: '10px',
                                boxSizing: 'border-box',
                                height: '50px',
                                textAlign: 'left',
                                '&:hover': {
                                    borderColor: 'var(--input-border-color)'
                                }
                            }),
                            container: (baseStyles) => ({
                                ...baseStyles,
                                width: '100%'
                            }),
                            placeholder: (baseStyles) => ({
                                ...baseStyles,
                                color: '#C1C1C1',
                                fontSize: '16px',
                                fontFamily: 'Lato'
                            }),
                            indicatorSeparator: (baseStyles) => ({
                                display: 'none'
                            }),
                            dropdownIndicator: (baseStyles) => ({
                                ...baseStyles,
                                paddingRight: '21px',
                                '& svg': {
                                    fill: 'var(--brand-color)'
                                }
                            })
                        }}
                        value={props.form1Details.type}
                        // onBlur={getFormErrors}
                        // defaultValue={props.form3Details.type}
                        onChange={(value) => {
                            props.setForm1DetailsHandler((prevState) => ({
                                ...prevState,
                                type: value
                            }));
                        }}
                    />
                </div> : null}
                {
                    props.form1Details.type?.value == 'product_quality' ||
                        props.form1Details.type?.value == 'air_bike_installation' ? <section className='w-100'>
                        <div className='d-flex tabs'
                            ref={scrollToRef}>
                            {
                                Object.keys(tabs).map((tab, indx, arr) => {
                                    if (props.form1Details.type?.value == 'air_bike_installation' && tab == 'pick-Up address') return;
                                    if (props.form1Details.type?.value == 'product_quality' && tab == 'purchase details') return;
                                    else return <span onClick={() => {
                                        if (completedSteps.includes(tab)) setActiveTab(arr[indx])
                                    }} className={activeTab == tab ? 'active' : ''} key={tab}>{tab}</span>
                                })
                            }
                        </div>
                    </section> : null
                }
                <div className={`${props.form1Details.type.value} ${fieldsToShow.includes(1) ? '' : 'justify-content-start'} fields-wrapper w-100`} id={activeTab.split(' ').join('-')}
                    style={{
                        border: props.form1Details.type?.value == 'product_quality' ||
                            props.form1Details.type?.value == 'air_bike_installation' ? '1px solid var(--input-border-color)' : '',
                        display: (activeTab == 'product details' && !['wrong_items', 'poor_quality', 'items_missing'].includes(props.form1Details.type?.value)) ? 'block' : ''
                    }}>
                    {['wrong_items', 'poor_quality', 'items_missing'].includes(props.form1Details.type?.value) ? <div className="did-floating-label-content"
                        style={{
                            width: '20vw'
                        }}>
                        <label className="did-floating-label">Complaint/Request Type<span className='text-danger'>*</span></label>
                        <Select
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable
                            name="type"
                            components={{ DropdownIndicator }}
                            placeholder="Select your complaint/request type"
                            options={complaintTypeOptions2}
                            styles={{
                                menu: (baseStyles) => ({
                                    ...baseStyles,
                                    zIndex: 2,
                                }),
                                menuList: (baseStyles) => ({
                                    ...baseStyles,
                                    textAlign: 'left',
                                }),
                                singleValue: (baseStyles) => ({
                                    ...baseStyles,
                                    textAlign: 'left'
                                }),
                                control: (baseStyles) => ({
                                    ...baseStyles,
                                    fontSize: '16px',
                                    background: '#fff',
                                    color: '#323840',
                                    border: '1px solid var(--input-border-color)',
                                    borderColor: 'var(--input-border-color)',
                                    borderRadius: '10px',
                                    boxSizing: 'border-box',
                                    height: '50px',
                                    textAlign: 'left',
                                    '&:hover': {
                                        borderColor: 'var(--input-border-color)'
                                    }
                                }),
                                container: (baseStyles) => ({
                                    ...baseStyles,
                                    width: '100%'
                                }),
                                placeholder: (baseStyles) => ({
                                    ...baseStyles,
                                    color: '#C1C1C1',
                                    fontSize: '16px',
                                    fontFamily: 'Lato'
                                }),
                                indicatorSeparator: (baseStyles) => ({
                                    display: 'none'
                                }),
                                dropdownIndicator: (baseStyles) => ({
                                    ...baseStyles,
                                    paddingRight: '21px',
                                    '& svg': {
                                        fill: 'var(--brand-color)'
                                    }
                                })
                            }}
                            value={props.form1Details.type}
                            // onBlur={getFormErrors}
                            // defaultValue={props.form3Details.type}
                            onChange={(value) => {
                                props.setForm1DetailsHandler((prevState) => ({
                                    ...prevState,
                                    type: value
                                }));
                            }}
                        />
                    </div> : null}
                    {getFields()}
                </div>

            </form >

            {/* modal open for sample video */}
            <Modal
                show={playVideo}
                onHide={() => setPlayVideo(false)}
                dialogClassName="modal-90w modal-dialog-centered video-popup"
                aria-labelledby="example-custom-modal-styling-title"
                style={{
                    border: "unset",
                    background: "transparent"
                }}
            >
                <Modal.Header style={{
                    position: "absolute",
                    top: "-25px",
                    right: "-10px",
                    zIndex: "1",
                    border: "unset",
                    border: "0px",
                }} >
                    <CloseButton style={{
                        border: "unset", background: "transparent", color: 'var(--error-color)',
                        fontSize: '35px'
                    }} onClick={() => setPlayVideo(false)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#FF0000" />
                            <path d="M12.843 7.15724C12.6336 6.94784 12.2942 6.94784 12.0848 7.15724L10 9.24187L7.91518 7.15705C7.70578 6.94765 7.36644 6.94765 7.15705 7.15705C6.94765 7.36644 6.94765 7.70578 7.15705 7.91518L9.24187 10L7.15705 12.0848C6.94765 12.2942 6.94765 12.6336 7.15705 12.843C7.36644 13.0523 7.70578 13.0523 7.91518 12.843L10 10.7581L12.0848 12.843C12.2942 13.0523 12.6336 13.0523 12.843 12.843C13.0523 12.6336 13.0523 12.2942 12.843 12.0848L10.7581 10L12.843 7.91518C13.0523 7.70578 13.0523 7.36644 12.843 7.15705V7.15724Z" fill="white" />
                        </svg>
                    </CloseButton>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        src="https://img.beatxp.com/prod/file/Adapter%20Verification.mp4"
                        allow="autoplay"

                        width={'100%'}
                        style={{
                            background: "#000",
                            border: "unset",
                            minHeight: "300px",
                            padding: "10px 0",
                            borderRadius: "5px"
                        }}
                        className="m-auto mb-3"></iframe>
                </Modal.Body>
            </Modal>

            {/* modal open for image */}
            <Modal
                show={showImage}
                onHide={() => setShowImage(false)}
                dialogClassName="modal-90w modal-dialog-centered images"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header style={{
                    position: "absolute",
                    top: "-25px",
                    right: "-10px",
                    zIndex: "1",
                    border: "unset",
                    border: "0px",
                }} >
                    <CloseButton style={{
                        color: 'var(--error-color)',
                        fontSize: '35px'
                    }} onClick={() => {
                        setShowImage(false); setTimeout(() => {
                            setImgSrc({ type: "", src: "" });
                        }, 1000);
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#FF0000" />
                            <path d="M12.843 7.15724C12.6336 6.94784 12.2942 6.94784 12.0848 7.15724L10 9.24187L7.91518 7.15705C7.70578 6.94765 7.36644 6.94765 7.15705 7.15705C6.94765 7.36644 6.94765 7.70578 7.15705 7.91518L9.24187 10L7.15705 12.0848C6.94765 12.2942 6.94765 12.6336 7.15705 12.843C7.36644 13.0523 7.70578 13.0523 7.91518 12.843L10 10.7581L12.0848 12.843C12.2942 13.0523 12.6336 13.0523 12.843 12.843C13.0523 12.6336 13.0523 12.2942 12.843 12.0848L10.7581 10L12.843 7.91518C13.0523 7.70578 13.0523 7.36644 12.843 7.15705V7.15724Z" fill="white" />
                        </svg>
                    </CloseButton>
                </Modal.Header>
                <Modal.Body>
                    {
                        imgSrc && imgSrc.type == 'img' ? <img className='w-100 h-100' src={imgSrc.src ? URL.createObjectURL(imgSrc.src) : ""} alt="uploaded img" />
                            : <video controls className='w-100 h-100' src={imgSrc.src ? URL.createObjectURL(imgSrc.src) : ""}></video>
                    }
                </Modal.Body>
            </Modal>

            {/* modal open for orders list */}
            <Modal
                show={showOrdersPopup}
                dialogClassName="modal-90w modal-dialog-centered orders-list-popup"
                aria-labelledby="example-custom-modal-styling-title"
                style={{
                    border: "unset",
                    background: "transparent",
                    zIndex: 22
                }}
            >
                <Modal.Header >
                    {/* <CloseButton style={{
                        border: "unset", background: "transparent", color: 'var(--error-color)',
                        fontSize: '35px'
                    }} onClick={() => {
                        setSelectedOrder({ name: '', isChecked: false });
                        setshowOrdersPopup(false);
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#FF0000" />
                            <path d="M12.843 7.15724C12.6336 6.94784 12.2942 6.94784 12.0848 7.15724L10 9.24187L7.91518 7.15705C7.70578 6.94765 7.36644 6.94765 7.15705 7.15705C6.94765 7.36644 6.94765 7.70578 7.15705 7.91518L9.24187 10L7.15705 12.0848C6.94765 12.2942 6.94765 12.6336 7.15705 12.843C7.36644 13.0523 7.70578 13.0523 7.91518 12.843L10 10.7581L12.0848 12.843C12.2942 13.0523 12.6336 13.0523 12.843 12.843C13.0523 12.6336 13.0523 12.2942 12.843 12.0848L10.7581 10L12.843 7.91518C13.0523 7.70578 13.0523 7.36644 12.843 7.15705V7.15724Z" fill="white" />
                        </svg>
                    </CloseButton> */}
                </Modal.Header>
                <Modal.Body>
                    {
                        ordersList && ordersList?.totalElements ? ordersList.allData.map(item => (
                            <label key={item.orderId} className="mb-3 orders-card" htmlFor={item.orderId}>
                                <Form.Check // prettier-ignore
                                    type={'radio'}
                                    id={item.orderId}
                                    name='order'
                                    checked={selectedOrder?.name === item.orderId && selectedOrder?.isChecked}
                                    onChange={(event) => {
                                        setSelectedOrder({
                                            isChecked: true,
                                            name: item.orderId,
                                            data: item
                                        })
                                    }}
                                />

                                <span className='details'>Order ID:&nbsp;&nbsp; <p>{item.orderId}</p></span>
                                <span className='details'>Order Date:&nbsp;&nbsp;<p>{moment(item.orderTime).format('DD-MM-YYYY')}</p></span>
                                <span className='details flex-column'>Items Ordered: {
                                    item.items?.length ? item.items.map((product, i) => (
                                        <p key={product.productId}>
                                            {i + 1}. {product.productName}
                                        </p>
                                    )) : null
                                }</span>
                            </label>
                        )) : null
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button type='button'
                        disabled={!selectedOrder?.name && !selectedOrder.isChecked}
                        className='btn btn-info w-90 mx-auto'
                        onClick={() => {
                            props.setForm3DetailsHandler(prev => ({ ...prev, orderId: selectedOrder?.name }))
                        }}>
                        Submit
                    </button>
                </Modal.Footer>
            </Modal>
        </div >
    );
}

export default CForm3;